<template>
  <div>
    <div class="leaderBox" v-if="showOrhide">
      <div class="newtext">新手指引</div>
      <img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
      <img src="../../assets/images/pop/dd/dingd.jpg" class="createNxs createNx1" v-if="status==1">
      <div class="createNxbtn" @click="nextcreateNx(status)">
        {{status==1?"我知道了":"我知道了"}}
      </div>
      <div class="bottomTip">
        <el-checkbox v-model="checked">下次不再提示</el-checkbox>
      </div>
    </div>
    <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'创建订单'}]" />
    <div class="h-piece" style="margin:20px">
      <!-------------------------------------------------------订单信息-------------------------------------------------------------------->
      <div class="h-pieceIn2">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>订单信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form label-position="right" :inline="true" ref="form0" :model="order" class="demo-ruleForm h-formbLine">
              <el-form-item label="项目名称" class="h-elformWrap-2" v-if="order.category1Name == '工程订单'">
                <el-input v-model="order.orderProjectName" readonly></el-input>
              </el-form-item>
              <el-form-item label="项目版本号" class="h-elformWrap-2" v-if="order.category1Name == '工程订单'">
                <el-input v-model="order.orderProjectCode" readonly></el-input>
              </el-form-item>
              <el-form-item label="项目备注" class="h-elformWrap-2" v-if="order.category1Name == '工程订单'">
                <el-input v-model="order.projectDescription" :title="order.projectDescription" readonly></el-input>
              </el-form-item>
              <el-form-item label="订单类型" class="h-elformWrap-2">
                <el-input v-model="xsqyStr" readonly></el-input>
              </el-form-item>
              <el-form-item label="创建人" class="h-elformWrap-2">
                <el-input v-model="this.order.cuname" readonly></el-input>
              </el-form-item>
              <el-form-item label="创建时间" class="h-elformWrap-2">
                <el-input v-model="this.order.cdate" readonly></el-input>
              </el-form-item>
              <el-form-item label="订购原因" prop="businessReason" class="h-elformWrap-2" v-if="showIsFree" :rules="[
							  { required: true, message: '请选择订购原因', trigger: 'change'},
							]">
                <brselect clearable category="business_reason" :v="order.businessReason" v-model="order.businessReason"></brselect>
              </el-form-item>
              <el-form-item label="业务原因" prop="businessReason" class="h-elformWrap-2" v-if="showRent" :rules="[
								  { required: true, message: '请选择业务原因', trigger: 'blur'},
								]">
                <brselect clearable category="business_reason" :v="order.businessReason" v-model="order.businessReason"></brselect>
              </el-form-item>

            </el-form>
          </div>
        </div>
      </div>
      <!-------------------------------------------------------订单信息-------------------------------------------------------------------->
      <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
      <div class="h-pieceIn2">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>客户信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form :model="order" ref="form1" label-position="right" :inline="true" class="demo-ruleForm h-formbLine">
              <el-form-item prop="soldToName" label="售达方名称" :rules="[
								  { required: true, message: '请输入售达方名称', trigger:['change', ' blur','input']},
								]" class="h-elformWrap-2">
                <el-input v-model="order.soldToName" placeholder="请输入" readonly>
                  <i v-if="selectDailishang" class="el-icon-search el-input__icon" slot="suffix" @click="openShoudf">
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item prop="soldToAreaName" label="售达方区域" class="h-elformWrap-2" v-if="!showIsFree">
                <el-input v-model="order.soldToAreaName" readonly placeholder="自带出"></el-input>
              </el-form-item>
              <el-form-item label="销售区域" :rules="[
								  { required: true, message: '请输入销售区域', trigger:['change', ' blur','input']},
								]" class="h-elformWrap-2" v-if="!showIsFree&&!showRent">
                <el-select v-model="order.salesregion" placeholder="请选择" @change="changeArea($event)" style="width:100%">
                  <el-option v-for="item in salesregionNameListFilter" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="customerChannelCode" label="客户渠道" :rules="[
								  { required: true, message: '请输入客户渠道', trigger:['change', ' blur','input']},
								]" class="h-elformWrap-2">
                <el-select v-model="order.customerChannelCode" placeholder="请选择" @change="cleanOrder()" style="width:100%">
                  <el-option v-for="item in customerChannelListFilter" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="isStockUp" label="是否备货" :rules="[
								  { required: true, message: '请输入是否备货', trigger: 'change'},
								]" class="h-elformWrap-2" v-if="!showIsFree&&!showRent">
                <brselect clearable category="shifou_keyong" :v="order.isStockUp" v-model="order.isStockUp"></brselect>
              </el-form-item>
              <!--                            <el-form-item prop="toCompanyname" label="收货单位" :rules="[
								  { required: true, message: '请输入收货单位', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                <el-input v-model="order.toCompanyname" placeholder="请输入"></el-input>
                            </el-form-item>-->
              <el-form-item label="收货单位" prop="toCompanyname" class="h-elformWrap-z" :clearable="true" :rules="[
								  { required: true, message: '请选择收货单位', trigger: 'blur'},
								]" v-if="!guanliren">
                <el-select v-model="order.toCompanyname" remote filterable :filter-method="showFormList" style="width:165px" :v="order.toCompanyname" clearable placeholder="请输入" :remote-method="showFormList">
                  <el-option v-for="(item) in addrList" :key="item.id" :label="item.deptName" :value="item.deptName">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收货单位"  class="h-elformWrap-z" :clearable="true" v-if="guanliren">
                <el-select v-model="order.toCompanyname" remote filterable :filter-method="showFormList" style="width:165px" :v="order.toCompanyname" clearable placeholder="请输入" :remote-method="showFormList">
                  <el-option v-for="(item) in addrList" :key="item.id" :label="item.deptName" :value="item.deptName">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="h-elformWrap-m" :clearable="true">
                <i class="el-icon-circle-plus" @click="createAddress"></i>
              </el-form-item>
              <!--                            <el-form-item prop="collageTypeCode" v-if="this.showCollage" label="细分学院" :rules="[
								  { required: true, message: '请选择细分学院', trigger: 'change'},
								]" class="h-elformWrap-2">
                                <brselect clearable category="collage_type"
                                          :v="order.collageTypeCode"
                                          v-model="order.collageTypeCode"></brselect>
                            </el-form-item>-->
              <el-form-item prop="contactName" label="收货联系人" :rules="[
								  { required: true, message: '请输入收货联系人', trigger: 'blur'},
								]" class="h-elformWrap-2">
                <el-input v-model="order.contactName" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="选择收货地址" readonly :rules="[{ required: true, message: '请输入选择收货地址', trigger:['change', ' blur','input']},]" prop="toAddress" class="h-elformWrap-2">
                <el-input clearable v-model="order.toAddress" readonly style="width:100%;">
                  <i class="el-icon-search el-input__icon" slot="suffix" @click="selectAreadialog">
                  </i>
                </el-input>
              </el-form-item>

              <el-form-item label="联系电话" width="300" :rules="[
								  { required: true, message: '请输入联系电话', trigger:['change', ' blur','input']},
								  { required: true, pattern: /^((\d+-\d+?)|(\d+))$/, message: '请输入正确的电话号码', trigger: 'blur' }
								]" class="h-elformWrap-2" prop="firsttelephone">
                <div class="block">
                  <el-input v-model="order.firsttelephone" placeholder="请输入"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="期望收货日期" class="h-elformWrap-2" width="100%" :rules="[
								  { required: true, message: '请选择期望收货日期', trigger: 'blur'},
								]" prop="receivedTime" v-if="!guanliren">
                <div class="block">
                  <el-date-picker v-model="order.receivedTime" type="date" :clearable="false" value-format="yyyy-MM-dd" placeholder="--请先选择期望收货日期--"  :picker-options="startDateLimit">
                  </el-date-picker>
                </div>
              </el-form-item>
              <el-form-item label="交货期" class="h-elformWrap-2" v-if="isYx" width="100%" :rules="[
								  { required: true, message: '请输入交货期', trigger: 'blur'},
								]" prop="saleManName">
                <el-input v-model="order.saleManName" placeholder="请输入"></el-input>
              </el-form-item>

              <el-form-item label="质保期" class="h-elformWrap-2" v-if="isYx" width="100%" :rules="[
								  { required: true, message: '请输入质保期', trigger: 'blur'},
								]" prop="saleManCode">
                <el-input v-model="order.saleManCode" placeholder="请输入"></el-input>
              </el-form-item>

              <el-form-item prop="currencyCode" label="币种" :rules="[
								  { required: true, message: '请输入币种', trigger: 'change'},
								]" class="h-elformWrap-2">
                <mdmselect clearable category="YLCurrency" :showcode="true" disabled :v="order.currencyCode" v-model="order.currencyCode"></mdmselect>
              </el-form-item>

              <el-form-item prop="kucun" label="库位" v-if="this.order.orderCategory1 == '4'" class="h-elformWrap-2">
                <brselect clearable category="order_shouh_kuwei" :v="order.kucun" v-model="order.kucun"></brselect>
              </el-form-item>

              <el-form-item prop="kucun" label="库位" :rules="[{ required: true, message: '请选择库位', trigger:['change', 'blur']},]" v-if="this.order.orderCategory1 == '6'" class="h-elformWrap-2">
                <brselect clearable category="nx_mianfei_kuwei" :v="order.kucun" v-model="order.kucun"></brselect>
              </el-form-item>

              <el-form-item prop="hhxmCode" label="项目合同" v-if="isHh" class="h-elformWrap-2">
                <el-select v-model="order.hhxmCode" filterable @change="changeHhxmCode(order.hhxmCode)" placeholder="请选择" clearable style="width:100%">
                  <el-option v-for="item in hhxmList" :key="item.id" :label="item.contractName +'-'+ item.id" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="startTime" label="质保开始时间" v-if="isHHxm" class="h-elformWrap-2" width="100%">
                <div class="block">
                  <el-date-picker v-model="order.startTime" type="date" :clearable="false" placeholder="--请先选择质保开始日期--" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </div>
              </el-form-item>
              <el-form-item prop="endTime" label="质保结束时间" v-if="isHHxm" class="h-elformWrap-2" width="100%">
                <div class="block">
                  <el-date-picker v-model="order.endTime" type="date" :clearable="false" placeholder="--请先选择质保开始日期--" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </div>
              </el-form-item>

              <el-form-item label="是否战略" class="h-elformWrap-2">
                <brselect clearable category="is_zhanlue" :v="order.isZl" v-model="order.isZl"></brselect>
              </el-form-item>

              <el-form-item label="战略附件" class="h-elformWrap-2">
                <brupload v-model="order.sgFileUrl" :refid=testID reftype="NX_ZLXY" :limit="1" :showtime="false" uploadflag delflag @filecallback=sgIsUpload>
                </brupload>
              </el-form-item>

              <el-form-item label="项目方案" class="h-elformWrap-2" required v-if="!guanliren">
                <brupload v-model="order.zlFileUrl" :refid=testID reftype="NX_ZLFJ" :limit="1" :showtime="false" uploadflag delflag @filecallback=zlIsUpload>
                </brupload>
              </el-form-item>

              <el-form-item v-if="this.zhidanflag&&!guanliren" label="直单附件" class="h-elformWrap-2" required>
                <el-upload style="margin-top: 0;" v-model="order.zmFile" class="upload-demo" action="" :http-request="httpRequest2" :on-remove="handleRemove2" :before-remove="beforeRemove" :before-upload="beforeUpload" multiple :file-list="fileList2" :auto-upload=true>
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>

              <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">订单为异地发货时，必须选择是否战略以及上传战略附件！！</h6>

            </el-form>
          </div>
        </div>
      </div>

      <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
      <div class="h-table h-mrt30 ljjtablepaddings2" style="margin: 10px 20px 0 10px;">
        <div class="h-pieceTitle2 message" style="margin-bottom: 0.3rem;">
          <h1 class="h1">套餐产品信息</h1>
          <el-button size="small" type="primary" icon="el-icon-circle-plus" style="margin-left: 50px;" @click="showPackage">选择套餐
          </el-button>
        </div>
        <div style="margin-bottom: 20px;" v-for="(item,index) in companyList" :key="index">
          <div class="combinatc">
            <span style="color: #4a4a4a">{{ item.name }}({{item.code}})</span>
            <el-button type="primary" size="mini" @click="deleteThis(index,item)">删除</el-button>
          </div>

          <!-- <el-select v-model="zhidanGsCode" placeholder="请选择" @change="chooseGsCode($event),$forceUpdate()" style="width:320px" v-if="chooseGscode">
            <el-option v-for="item in zhidanCompanycode" :key="item.key" :label="item.value" :value="item.key">
            </el-option>
          </el-select> -->

          <!-- <el-form label-position="right" :inline="true" ref="form9390" :model="order" class="demo-ruleForm h-formbLine" style="width: 100%;margin-top: 20px;">
            <el-form-item label="成本中心" prop="costCenter9390" v-if="showIsFree&&!showIsFreeSh" style="width: 50%;" :rules="[
					  { required: true, message: '请选择成本中心', trigger: 'change'},
					]">
              <el-select v-model="order.costCenter9390" style="width: 350px;" clearable filterable placeholder="--选择--">
                <el-option v-for="item in costList9390" :key="item.index" :label="`${item.costCenterCode} : ${item.remark}`" :value="item.costCenterCode"></el-option>
              </el-select>
            </el-form-item>
          </el-form> -->
          <!-- 套餐数据 -->
          <!-- <el-table ref="multipleTable" :data="packageTable" stripe border style="width: 100%" v-if="!guanliren">
            <el-table-column type="index" label="#" width="40">
            </el-table-column>
            <el-table-column prop="lianqunName" label="链群" :show-overflow-tooltip="true" width="150">
            </el-table-column>
            <el-table-column prop="sceneName" label="场景" :show-overflow-tooltip="true" width="150">
            </el-table-column>

            <el-table-column prop="packageName" label="套餐名称" :show-overflow-tooltip="true" width="150">
            </el-table-column>
            <el-table-column prop="proNumber" label="套餐数量" width="120">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.proNumber" placeholder="请输入" @change="changeProNum(scope.row)" class="DshuR h-tableInput" auto-complete="off"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="finalPrice" label="成交价" width="120">
            </el-table-column>
            <el-table-column prop="jinejjz" label="净价值" width="90">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ scope.row.jinejjz = new
                                    big(scope.row.finalPrice).div(scope.row.taxRate).toFixed(2).toString()}}</div>
              </template>
            </el-table-column>

            <el-table-column prop="totalprice" label="总价" width="120">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ scope.row.totalprice = new big(scope.row.proNumber ||
                                    0).times((scope.row.finalPrice||0)).toFixed(2).toString() }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="note1" label="备注" min-width="160">
              <template slot-scope="scope">
                <el-input class="h-tableInput" v-model="scope.row.note1" placeholder="请输入" @change="saveRemark(scope.row)" auto-complete="off"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" v-if="showdelProductRow" width="100" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="small" class="h-tableLink h-btn" @click="deleteTc(scope.row)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table> -->
          <!-- 套餐下产品数据 -->
          <el-table ref="multipleTableRef" :data="item.list" stripe border style="width: 100%">
            <el-table-column type="index" label="#" width="30">
            </el-table-column>
            <el-table-column prop="proModelName" label="产品大类" :show-overflow-tooltip="true" min-width="80">
            </el-table-column>
            <el-table-column prop="materialCode" label="产品编码" :show-overflow-tooltip="true" min-width="95">
            </el-table-column>
            <el-table-column min-width="120" prop="materialName" :show-overflow-tooltip="true" label="产品名称">
              <template slot-scope="scope">
                <div style="text-align: left;">{{scope.row.materialName}}</div>
              </template>
            </el-table-column>
            <el-table-column min-width="120" prop="oemDesc" :show-overflow-tooltip="true" label="规格型号">
              <template slot-scope="scope">
                <div style="text-align: left;">{{scope.row.oemDesc}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="factory" label="产地" :show-overflow-tooltip="true" min-width="60">
            </el-table-column>
            <el-table-column prop="proNumber" label="订单数量" min-width="80">
              <template slot-scope="scope">
                <!-- <el-input v-if="scope.row.orderField&&scope.row.orderField==1" v-model="scope.row.proNumber" @input="bindInputNum(scope.row)" placeholder="请输入" class="DshuR h-tableInput" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" auto-complete="off"></el-input> -->
                <div>{{scope.row.proNumber}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="proBenchmarkPrice" :label="priceName" :show-overflow-tooltip="true" min-width="70">
              <template slot-scope="scope">
                <div style="text-align: right;">{{scope.row.proBenchmarkPrice}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="currencyCode" label="币种" :show-overflow-tooltip="true" min-width="60">
              <template slot-scope="scope">
                <div style="text-align: right;">{{scope.row.currencyCode}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="finalPrice" label="成交价" min-width="80">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.finalPrice" placeholder="请输入" @input="bindInputNum(scope.row,index,'CJJ')" class="DshuR h-tableInput" auto-complete="off"></el-input>
              </template>
            </el-table-column>

            <!-- <el-table-column v-if="obj.code == '44U0'" prop="finalPrice" label="成交价" width="100">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.finalPrice" placeholder="请输入" @change="change44U0finalPrice(scope.row)" class="DshuR h-tableInput" auto-complete="off"></el-input>
              </template>
            </el-table-column> -->

            <el-table-column prop="jinejjz" label="净价值" min-width="70">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ scope.row.jinejjz}}</div>
              </template>
            </el-table-column>

            <el-table-column prop="totalprice" label="总价" min-width="70">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ scope.row.totalprice}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="yidishpyj" label="客户型号" min-width="160">
              <template slot-scope="scope">
                <el-input class="h-tableInput" v-model="scope.row.yidishpyj" placeholder="请输入"  @change="addPackageList(scope.row)"  auto-complete="off"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="业务类型" v-if="guanliren" min-width="100">
              <template slot-scope="scope" v-if="scope.row.proType=='OEM'">
                <el-select v-model="scope.row.zhifakufa" :clearable="true"  placeholder="请选择">
                  <el-option label="直发" :value="1"></el-option>
                  <el-option label="库发" :value="2"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="note1" label="备注" min-width="120">
              <template slot-scope="scope">
                <el-input class="h-tableInput" v-model="scope.row.note1" @change="addPackageList(scope.row)" placeholder="请输入" auto-complete="off"></el-input>
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button v-if="scope.row.orderField&&scope.row.orderField==1" type="text" size="small" class="h-tableLink h-btn" @click="deleteThis(scope.$index,scope.row)">
                  删除
                </el-button>
              </template>
            </el-table-column> -->
          </el-table>
          <!-- <div class="h-tableAdd" @click="addProducts" v-if="guanliren">
            <a>选择产品</a>
          </div> -->
          <div class="jieguo w-newIcon">
            <span class="jieguo_label">订单总价</span>
            <span class="jieguo_value">{{  item.orderData.orderPrice }}</span>
            <span class="jieguo_label">现金余额</span>
            <span class="jieguo_value">{{ item.orderData.xianjye}}</span>
            <span class="jieguo_label">现金占用</span>
            <span class="jieguo_value">{{ item.orderData.orderPriceXj}}</span>
            <span class="jieguo_label">现金欠款</span>
            <span class="jieguo_value">{{  item.orderData.orderPriceXjQk }}</span>
            <span class="jieguo_label">净价值</span>
            <span class="jieguo_value">{{item.orderData.orderNetWorth}}</span>
          </div>
        </div>

      </div>

      <div class="h-table h-mrt30 ljjtablepaddings2" style="margin: 10px 20px 0 10px;">
        <div class="h-pieceTitle2 message" style="margin-bottom: 0.3rem;">
          <h1 class="h1">产品信息</h1>
          <el-button size="small" type="primary" icon="el-icon-circle-plus" style="margin-left: 50px;" @click="addProducts">选择产品
          </el-button>
        </div>
        <div style="margin-bottom: 20px;" v-if="productList.length>0">
          <!-- <div class="combinatc">
            <span style="color: #4a4a4a">{{ item.name }}({{item.code}})</span>
            <el-button type="primary" size="mini" @click="deleteThis(index,item)">删除</el-button>
          </div> -->

          <!-- <el-select v-model="zhidanGsCode" placeholder="请选择" @change="chooseGsCode($event),$forceUpdate()" style="width:320px" v-if="chooseGscode">
            <el-option v-for="item in zhidanCompanycode" :key="item.key" :label="item.value" :value="item.key">
            </el-option>
          </el-select> -->

          <!-- <el-form label-position="right" :inline="true" ref="form9390" :model="order" class="demo-ruleForm h-formbLine" style="width: 100%;margin-top: 20px;">
            <el-form-item label="成本中心" prop="costCenter9390" v-if="showIsFree&&!showIsFreeSh" style="width: 50%;" :rules="[
					  { required: true, message: '请选择成本中心', trigger: 'change'},
					]">
              <el-select v-model="order.costCenter9390" style="width: 350px;" clearable filterable placeholder="--选择--">
                <el-option v-for="item in costList9390" :key="item.index" :label="`${item.costCenterCode} : ${item.remark}`" :value="item.costCenterCode"></el-option>
              </el-select>
            </el-form-item>
          </el-form> -->
          <!-- 套餐数据 -->
          <!-- <el-table ref="multipleTable" :data="packageTable" stripe border style="width: 100%" v-if="!guanliren">
            <el-table-column type="index" label="#" width="40">
            </el-table-column>
            <el-table-column prop="lianqunName" label="链群" :show-overflow-tooltip="true" width="150">
            </el-table-column>
            <el-table-column prop="sceneName" label="场景" :show-overflow-tooltip="true" width="150">
            </el-table-column>

            <el-table-column prop="packageName" label="套餐名称" :show-overflow-tooltip="true" width="150">
            </el-table-column>
            <el-table-column prop="proNumber" label="套餐数量" width="120">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.proNumber" placeholder="请输入" @change="changeProNum(scope.row)" class="DshuR h-tableInput" auto-complete="off"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="finalPrice" label="成交价" width="120">
            </el-table-column>
            <el-table-column prop="jinejjz" label="净价值" width="90">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ scope.row.jinejjz = new
                                    big(scope.row.finalPrice).div(scope.row.taxRate).toFixed(2).toString()}}</div>
              </template>
            </el-table-column>

            <el-table-column prop="totalprice" label="总价" width="120">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ scope.row.totalprice = new big(scope.row.proNumber ||
                                    0).times((scope.row.finalPrice||0)).toFixed(2).toString() }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="note1" label="备注" min-width="160">
              <template slot-scope="scope">
                <el-input class="h-tableInput" v-model="scope.row.note1" placeholder="请输入" @change="saveRemark(scope.row)" auto-complete="off"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" v-if="showdelProductRow" width="100" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="small" class="h-tableLink h-btn" @click="deleteTc(scope.row)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table> -->
          <!-- 套餐下产品数据 -->
          <el-table ref="multipleTableRef" :data="productList" stripe border style="width: 100%">
            <el-table-column type="index" label="#" width="30">
            </el-table-column>
            <el-table-column prop="proModelName" label="产品大类" :show-overflow-tooltip="true" min-width="80">
            </el-table-column>
            <el-table-column prop="materialCode" label="产品编码" :show-overflow-tooltip="true" min-width="95">
            </el-table-column>
            <el-table-column min-width="120" prop="materialName" :show-overflow-tooltip="true" label="产品名称">
              <template slot-scope="scope">
                <div style="text-align: left;">{{scope.row.materialName}}</div>
              </template>
            </el-table-column>
            <el-table-column min-width="120" prop="oemDesc" :show-overflow-tooltip="true" label="规格型号">
              <template slot-scope="scope">
                <div style="text-align: left;">{{scope.row.oemDesc}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="factory" label="产地" :show-overflow-tooltip="true" min-width="60">
            </el-table-column>
            <el-table-column prop="proNumber" label="订单数量" min-width="80">
              <template slot-scope="scope">
                <el-input v-model="scope.row.proNumber" @input="bindInputNum2(scope.row)" placeholder="请输入" class="DshuR h-tableInput" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" auto-complete="off"></el-input>
                <!-- <div>{{scope.row.proNumber}}</div> -->
              </template>
            </el-table-column>
            <el-table-column prop="proBenchmarkPrice" :label="priceName" :show-overflow-tooltip="true" min-width="70">
              <template slot-scope="scope">
                <div style="text-align: right;">{{scope.row.proBenchmarkPrice}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="currencyCode" label="币种" :show-overflow-tooltip="true" min-width="60">
              <template slot-scope="scope">
                <div style="text-align: right;">{{scope.row.currencyCode}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="finalPrice" label="成交价" min-width="80">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.finalPrice" placeholder="请输入" @input="bindInputNum2(scope.row,'CJJ')" class="DshuR h-tableInput" auto-complete="off"></el-input>
              </template>
            </el-table-column>

            <!-- <el-table-column v-if="obj.code == '44U0'" prop="finalPrice" label="成交价" width="100">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.finalPrice" placeholder="请输入" @change="change44U0finalPrice(scope.row)" class="DshuR h-tableInput" auto-complete="off"></el-input>
              </template>
            </el-table-column> -->

            <el-table-column prop="jinejjz" label="净价值" min-width="70">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ scope.row.jinejjz}}</div>
              </template>
            </el-table-column>

            <el-table-column prop="totalprice" label="总价" min-width="70">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ scope.row.totalprice}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="yidishpyj" label="客户型号" min-width="160">
              <template slot-scope="scope">
                <el-input class="h-tableInput" v-model="scope.row.yidishpyj" placeholder="请输入" auto-complete="off"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="业务类型" v-if="guanliren" min-width="100">
              <template slot-scope="scope" v-if="scope.row.proType=='OEM'">
                <el-select v-model="scope.row.zhifakufa" :clearable="true"  placeholder="请选择">
                  <el-option label="直发" :value="1"></el-option>
                  <el-option label="库发" :value="2"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="note1" label="备注" min-width="120">
              <template slot-scope="scope">
                <el-input class="h-tableInput" v-model="scope.row.note1" placeholder="请输入" auto-complete="off"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" class="h-tableLink h-btn" @click="deleteThis2(scope.$index,scope.row)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

      </div>
      <!--------------------------------------------------------------------收货地址弹出框-------------------------------------------------------->
      <!--售达方-->
      <shoudf :visible.sync="showshdfdialog" v-if="showshdfdialog" @choseObj="choseshoudf" oneflag :usercode="currentUser" :xmcode="xmcode" :ddlx="ddlx" :xszz="order.saleGroupCode" title="选择售达方" />
      <!--地址信息-->
      <areaSelect :visible.sync="showdizhiflag" v-if="showdizhiflag" @choseObj="choseDizhi" />
      <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid" />
      <selectPackage :visible.sync="packageFlag" @choseObj="chosePackage" :detailFlag="detailFlag" :agentCode="this.order.soldToCode" :companycode="this.tcGsCode" v-if="packageFlag" title="选择套餐" orderType="zh" />
      <wxwl :visible.sync="showwuliaodialog" v-if="showwuliaodialog" @choseObj="bindChoseWuliao" :usercode="order.soldToCode" :ddlx="ddlx" :xmcode="xmcode" :currencyCode="order.currencyCode" :customerChannelCode="order.customerChannelCode" :areaCode="order.salesregion" :cpdlcode="cpdlcode" title="选择物料" />
    </div>
    <div v-if="taskstatus=='0'">
      <div class="anniu" v-if="!resubmit">
        <el-row>
          <el-button class="h-btn h-bBtn h-bgwhite" @click="backtolist">返回</el-button>
          <el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(10)">暂存</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveOrSubmit(20)">确认提交</el-button>
        </el-row>
      </div>
      <div class="anniu" v-else>
        <el-row>
          <el-button class="h-btn h-bBtn h-bgwhite" @click="backtolist">返回</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="resaveOrSubmit(20)">重新提交</el-button>
          <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
        </el-row>
      </div>
    </div>
    <div class="anniu" v-if="taskstatus == '1'">
      <el-row>
        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="this.$store.dispatch('backToTaskIndex')">返回</el-button>
      </el-row>
    </div>
    <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="institutionalX" class="h-dialog2">
      <companyName ref="companyName" :titleName="titleDig" :add1="add" :stVal="stVal" @getChildValue="closeCompanyName"></companyName>
    </el-dialog>
    <!--        <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="newDialog" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>{{titleDig}}</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines">
&lt;!&ndash;                <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">单位名称为大学时，请按实际情况维护用户分类(211/985)</h6>&ndash;&gt;
                <el-form ref="form" :model="add" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                    <el-form-item  label="单位名称" class="h-elformWrap-2" label-width="100" prop="deptName" :rules="[{ required: true, message: '请输入单位名称', trigger: 'blur'},]">
&lt;!&ndash;                        <el-input v-model="add.deptName" placeholder="请输入单位名称"></el-input>&ndash;&gt;
&lt;!&ndash;                        <img :src="mapSrc" @click="mapHandleShow" title="地图选点[快速录入]" style="cursor: pointer;width: 20px; margin-top: -20px;vertical-align:bottom"/>&ndash;&gt;
                        <el-select v-model="add.deptName"  remote filterable :filter-method="selectDept" clearable placeholder="请输入" allow-create filterable
                                   :remote-method="selectDept" @change="changeDeptName($event)" :rules="[{ required: true, message: '请输入单位名称', trigger: 'change'},]">
                            <el-option v-for="(item) in deptNameList"
                                       :key="item.deptName"
                                       :label="item.deptName"
                                       :value="item.deptName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="渠道" class="h-elformWrap-2" label-width="100" prop="deptSourceChannel" :rules="[{ required: true, message: '请选择渠道', trigger: 'blur'},]">
                        <brselect category="sales_region" :v="add.deptSourceChannel" :showcode="true" @change="changeChannel($event)"
                                  v-model="add.deptSourceChannel" clearable></brselect>
                    </el-form-item>
                    <el-form-item  label="用户分类" class="h-elformWrap-2" label-width="100" prop="schoolTypeName" :rules="[{ required: true, message: '请输入用户分类', trigger: 'change'},]">
                      <el-select v-model="add.schoolTypeName"
                                 @change="changeSchoolType($event)"  placeholder="请选择" clearable>
                        <el-option v-for="item in addressTypeList"
                                   :key="item.id"
                                   :label="item.userUnit"
                                   :value="item.userUnit">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="省" class="h-elformWrap-2" prop="province" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
                        <el-select v-model="add.province" @change="handleItemChange1" placeholder="省" >
                            <el-option
                                    v-for="item in shenglist"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="市" class="h-elformWrap-2" prop="city"
                                  :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
                        <el-select v-model="add.city" @change="handleItemChange2"
                                   :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                                   placeholder="市" >
                            <el-option
                                    v-for="item in arealist2"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="区" class="h-elformWrap-2" prop="area"
                                  :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
                        <el-select v-model="add.area"
                                   :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                                   placeholder="区" @change="handleItemChange3">
                            <el-option
                                    v-for="item in arealist3"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="上级" class="h-elformWrap-1" label-width="100" prop="deptName">
                        <treeselect
                                :multiple="false"
                                :options="options"
                                :flat="true"
                                :default-expand-level="1"
                                placeholder="请选择"
                                v-model="stVal"
                        />
                        <treeselect-value :value="stVal" />
                    </el-form-item>
                    <el-form-item label="详细地址" class="h-elformWrap-1"
                                  :rules="[
                        { required: true, message: '必须输入选项', trigger: 'blur'},
                        {  max: 30, message: '长度在30个字符以内', trigger: 'blur' }
                    ]"
                                  prop="address">
                        <el-input v-model="add.address" style="width: 84%;"></el-input>
                    </el-form-item>
                </el-form>
                <div style="display:flex;justify-content:center;margin-bottom:20px">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
                </div>
            </div>
        </el-dialog>-->
  </div>
</template>
<script>
import big from 'big.js'
import ss from '../../api/SystemService'
import wxwl from '../../components/dialog/wxwl'
import shoudf from '../../components/dialog/selectshdf'
import selectPackage from '../../components/project/addPackage';

// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import uploadFile from "../../api/process/account_complainUploadService";

import uploaddown from '../../utils/updownfile'
import _ from "loadsh";
import companyName from "@/components/basic/companyName.vue";
export default {
  components: {
    companyName,
    shoudf,
    selectPackage,
    Treeselect,
    wxwl
  },
  filters: {
    gsname: function (v) {
      return _.find(this.allxszz, { code: v }).name;
    },
    numFilter (value) {
      let realVal = ''
      if (value) {
        // 截取当前数据到小数点后两位
        realVal = parseFloat(value).toFixed(2) * 100 + '%'
      } else {
        realVal = '--'
      }
      return realVal
    }
  },
  data () {
    return {
      institutionalX: false,
      orderNu: -1,
      testID: '',
      submitChongfuFlag: true,
      ydgFlag: false,
      priceForShow: "",
      priceName: "基准价",
      contract: "",
      showRent: false,
      showSampleHetong: false,
      contractName: "",
      contractStarttime: "",
      contractEndtime: "",
      checked: true,
      showOrhide: false,
      status: 1,
      toshow: 'createNxOrder2',
      costList9390: [],
      costList9370: [],
      costList1D90: [],
      costList1JC0: [],
      costList1RK0: [],
      costList9391: [],
      costList1R60: [],
      costList0PN0: [],
      costList1S00: [],
      costList1S40: [],
      costList44U0: [],
      costList45K0: [],
      isA33: false,
      showSamplePro: false,
      showIsFree: false,
      showIsFreeSh: false,
      resubmit: false,
      instid: null,
      taskstatus: 0,
      //时候售后订单
      showshouhouflag: false,
      showhistory: false,
      selectDailishang: true,


      showshdfdialog: false,
      showdizhiflag: false,
      currentUser: null,
      showdelProductRow: true,
      showaddProductRow: true,

      //上海的采购毛利率
      showShcgmll: false,
      //是否可以选择时间
      startDateLimit: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() + 5 * 24 * 3600 * 1000
        }
      },
      openReceivedTimedisabled: true,
      //特价
      tejieshowflag: false,
      //定制展示
      dingzhishowflag: false,
      //现金余额
      cashBalance: 0,
      //展会项目不展示合同号
      contractflag: true,
      xmcode: null,
      //销售组织
      allxszz: [],
      //订单类型
      ddlx: null,
      //是否直单用户
      zhidanflag: 0,
      companycodes: "",
      isBlood: 0,
      chooseGscode: false,
      zhidanGsCode: "",



      //行项目
      productlist9390: [],
      productlist9370: [],
      productlist9391: [],
      productlist1D90: [],
      productlist1JC0: [],
      productlist1RK0: [],
      productlist1R60: [],
      productlist0PN0: [],
      productlist1S00: [],
      productlist1S40: [],
      productlist44U0: [],
      productlist45K0: [],
      packageList: [],
      packageList1: [],
      packageTable: [],
      productList: [],
      position: '',
      //对象
      order9390: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order9370: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order9391: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1D90: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1JC0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1RK0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1R60: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order0PN0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },

      order1S00: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        hhxmCode: null,//厚宏项目id
        startTime: null,//质保开始时间
        endTime: null,//质保结束时间
        creditData: [],
      },
      order1S40: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        hhxmCode: null,//厚宏项目id
        startTime: null,//质保开始时间
        endTime: null,//质保结束时间
        creditData: [],
      },
      order44U0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        hhxmCode: null,//厚宏项目id
        startTime: null,//质保开始时间
        endTime: null,//质保结束时间
        creditData: [],
      },
      order45K0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        hhxmCode: null,//厚宏项目id
        startTime: null,//质保开始时间
        endTime: null,//质保结束时间
        creditData: [],
      },
      package: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
        gscode: null,
      },
      tcData: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
        gscode: null,
      },
      order: {
        id: null, // 主键
        orderMainContract: null, // 主合同编号
        orderSubContract: null, // 分合同编号
        orderProjectCode: null, // 项目编号
        orderProjectName: null, // 项目名称
        projectDescription: null, // 项目描述
        orderCategory: null, // 订单类型
        orderCategory1: null, // 订单详细类型:1-10为内销：1-工程,2-标准,3-改制,4-售后,5-样品机,6-免费,7-展会,8-租赁,9-服务,10-OEM,
        saleGroupCode: null, // 销售组织编码:6200-青岛海尔生物医疗-香港销组织,9390-青岛,9391-上海,9370-青岛海特生物医疗-销售组织
        disChannelCode: null, // 分销渠道编码:00-通用分销渠道,X1-香港外销渠道,Z1-上海直销渠道
        zCode: null, // 分销渠道编码-子编码
        customerChannelCode: null, // 客户渠道
        isStockUp: null, // 是否备货      1：是；0：否
        orderStatus: null, // 订单状态： 10:暂存  20:审核中, 21:订单管理员通过, 22:订单管理员未通过, 23:财务经理未通过, 24:财务经理通过   30:sap已提交,31:sap待审核,32:sap已通过
        instid: null, // 流程id
        taskId: null, // 流程id
        tuihyy: null, // 退货原因
        tuihyydes: null, // 退货原因说明
        contactName: null, // 联系人名称
        receivedTime: null, // 预计收货时间
        soldToCode: null, // 售达方编码
        soldToName: null, // 售达方名称
        salesregion: null, // 售达方销售区域
        salesregionName: null, // 售达方销售区域名称
        soldToAreaCode: null, // 售达方地区编码
        soldToAreaName: null, // 售达方地区名称
        shipToCode: null, // 送达方编码
        shipToName: null, // 送达方名称
        shipToAreaCode: null, // 送达方地区编码
        invoiceCode: null, // 开票方编码
        payerCode: null, // 付款方编码
        currencyCode: null, // 币种编码
        orderPrice: 0, // 订单总价
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        poId: null, // PO号
        areaId: null, // 区域详情表关联id
        dcCode: null, // 配送中心编码
        toProvincesCode: null, // 送达省份编码
        toCityCode: null, // 送达城市编码
        note: null, // 订单备注
        note1: null,//产品备注
        yidishpyj: null,//客户型号,元析公司使用
        postcode: null, // 邮政编码
        firsttelephone: null, // 第一个电话
        secondtelephone: null, // 第二电话
        extraPrice: null, // 定制加价
        customized: null, // 定制需求
        sapsended: null, // 是否已提交sap,1-是,0-否
        toAddress: null, // 收货地址
        toCompanyname: null, // 送达方公司全称
        posnr: null, // 外销:销售和分销凭证的项目号
        inco1: null, // 外销:国际贸易条款 (部分1)
        inco2: null, // 外销:国际贸易条款 (部分2)
        submitflag: null,//提交标志
        categoryName: null,
        category1Name: null,
        saleGrputName: null,
        disChannelName: null,
        zcodeName: null,
        expoPrice: null,//展会价
        fktj: null, //付款条件

        costCenter9390: null,
        costCenter9370: null,
        costCenter9391: null,
        costCenter1D90: null,
        costCenter1JC0: null,
        costCenter1RK0: null,
        costCenter1R60: null,
        costCenter0PN0: null,
        costCenter1S00: null,
        costCenter1S40: null,
        costCenter44U0: null,
        costCenter45K0: null,

        businessReason: null,

        kucun: null,//库存地点
        lkfileUrl: null,
        fileUrl: [],
        sgFileUrl: null,
        csFileUrl: null,
        isStandard: 1,
        isZl: '',
        zmFile: null,
        upload2: [],
        collageTypeCode: null,
      },
      //产品list
      productlist1: [],
      productlist2: [],
      //客户渠道list
      customerChannelList: [],
      customerChannelListFilter: [],

      salesregionNameList: [],
      salesregionNameListFilter: [],

      lkFlag: false,
      csFlag: false,
      isHHxm: false,
      isHh: false,
      isYx: false,

      rules: {
        cwddh: [
          { required: true, message: '请输入财务订单号', trigger: 'blur' },
        ],
        fileUrl: [
          { required: true, message: '请上传方案图纸', trigger: 'blur' }
        ],
        sgFileUrl: [
          { required: true, message: '请上传施工确认单', trigger: 'blur' }
        ],
        csFileUrl: [
          { required: true, message: '请上传投标参数', trigger: 'blur' }
        ]
      },
      bomCodeList: [],
      packageFlag: false,
      tcFlag: false,
      detailFlag: false,
      tcGsCode: null,
      tcUnitNum: 0,
      zhidanCompanycode: [],
      remark: '',
      addrList: [],
      hhxmList: [],
      newDialog: false,
      add: {
        id: '',
        deptName: '',
        deptType: '',
        leader: '',
        phone: '',
        email: '',
        status: '',
        countryId: '',
        country: '',
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        areaId: '',
        landmark: '',
        area: '',
        shengobj: '',
        shiobj: '',
        quobj: '',
        selectId: '',
        address: '',
        subFlag: '',
        deptSourceChannel: '',
        longitude: '',
        latitude: '',
        parentCode: '',
        schoolTypeName: '',
      },
      mapDialogVisible: false,
      deptNameList: [],
      addressTypeList: [],
      shenglist: [],
      arealist2: [],
      arealist3: [],
      titleDig: false,
      proSelect: {
        pcode: 0,
        level: 1,
      },
      options: [],
      stVal: null,
      reftype2: 'NX_ZMFJ',
      fileList2: [],
      idList: [],
      showCollage: false,
      //所用公司信息
      companyInfoList: [],
      guanliren: false,
      showwuliaodialog: false,
      cpdlcode: 'YX1',
      companyList: [],
      companyListZc: []
    }
  },

  //页面加载前事件
  created () {
    //所用公司信息
    this.companyInfoList = this.$store.getters.dictlist("company_info");
    // 当前权限
    this.guanliren = this.$store.getters.hasRole("swyl_xiaoshoujl_yx,yx_shouhoujl");

    if (this.$route.query.id == '' || this.$route.query.id == undefined) {
      this.testID = this.$route.query.ywid
    } else {
      this.testID = this.$route.query.id
    }
    this.order.fileUrl = []
    this.order.sgFileUrl = []
    this.order.csFileUrl = []
    console.log('我在这儿呀', this.$route.query.chongXinTiJiao);
    this.showzhezhao()
    this.allxszz = this.$store.getters.dictlist('YLSalesOrganization_agent');
    this.customerChannelList = this.$store.getters.dictlist("sales_region");
    this.salesregionNameList = this.$store.getters.dictlist("YlSalesArea_chanpin");

    let id = this.$route.query.ywid;
    console.log(this.testID)
    let instid = this.$route.query.instid;
    let taskid = this.$route.query.taskid;
    let taskstatus = this.$route.query.taskstatus | 0;
    let chongXinTiJiao = this.$route.query.chongXinTiJiao;
    //代办打开的
    if (id && instid) {
      this.resubmit = true;
      //如果不是重新提交,则不能添加跟删除了
      if (!chongXinTiJiao) {
        this.showaddProductRow = false;
        this.showdelProductRow = false;
      }

      this.instid = instid;
      this.taskstatus = taskstatus;
      this.order.taskId = taskid;
      if (taskstatus == '1') {
        // 直接设置经销商
        this.selectDailishang = false;
        const parent = document.querySelector(".input");
        parent.className = "input el-input ";//改变父集的class,把父集改成可编辑状态，
        //2.在设置input属性
        //获取input
        const input = document.querySelector(".input input");
        //设置input的属性为false
        input.disabled = false;
      }
    }
    this.getOrder(id || this.$route.query.id);
    // this.order.customerChannelCode = null;
    this.getParentInfo();
  },

  computed: {
    xsqyStr () {
      if (this.order.category1Name) {
        return this.order.categoryName + "/" + this.order.category1Name
      }
      return this.order.categoryName
    },
  },
  watch: {
    /*            packageList: {
                    immediate: true,
                    deep: true,
                    handler(newValue, oldValue) {
                       //计算总金额
                        this.package.orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
                            return new big(sum).plus(v||0).toString();
                        }, 0)
                        //计算总净价值
                          this.package.orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
                             return new big(sum).plus(v||0).toString();
                         }, 0)
                        //重新计算信贷
                        if (this.package.creditid) {
                            if(this.package.gscode == '9390'){
                                this.creditChange(this.package.creditid, '9390');
                            }else if (this.package.gscode == '9370') {
                                this.creditChange(this.package.creditid, '9370');
                            }else if (this.package.gscode == '1D90') {
                                this.creditChange(this.package.creditid, '1D90');
                            }else if (this.package.gscode == '1RK0') {
                                this.creditChange(this.package.creditid, '1RK0');
                            }
                        }
                    },
                },*/
    // packageTable: {
    //   immediate: true,
    //   deep: true,
    //   handler (newValue, oldValue) {
    //     //计算总金额
    //     this.tcData.orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
    //       return new big(sum).plus(v || 0).toString();
    //     }, 0)
    //     //计算总净价值
    //     this.tcData.orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
    //       return new big(sum).plus(v || 0).toString();
    //     }, 0)
    //     //重新计算信贷
    //     if (this.tcData.creditid) {
    //       if (this.tcData.gscode) {
    //         this.creditChange(this.tcData.creditid, this.tcData.gscode);
    //       }

    //       /*if(this.tcData.gscode == '9390'){
    //            this.creditChange(this.tcData.creditid, '9390');
    //        }else if (this.tcData.gscode == '9370') {
    //            this.creditChange(this.tcData.creditid, '9370');
    //        }else if (this.tcData.gscode == '1D90') {
    //            this.creditChange(this.tcData.creditid, '1D90');
    //        }else if (this.tcData.gscode == '1JC0') {
    //            this.creditChange(this.tcData.creditid, '1JC0');
    //        }else if (this.tcData.gscode == '1RK0') {
    //            this.creditChange(this.tcData.creditid, '1RK0');
    //        }*/
    //     }
    //   },
    // },
    // packageList: {
    //   immediate: true,
    //   deep: true,
    //   handler (newValue, oldValue) {
    //     //计算总金额
    //     this.tcData.orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
    //       return new big(sum).plus(v || 0).toString();
    //     }, 0)
    //     //计算总净价值
    //     this.tcData.orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
    //       return new big(sum).plus(v || 0).toString();
    //     }, 0)
    //   },
    // },
  },
  mounted () {

  },
  methods: {
    // 新增单产品相关订单数量以及成交价输入
    bindInputNum2 (list, type) {
      if (type == "CJJ") {
        list.proBenchmarkPrice = list.finalPrice;
      }
      list.jinejjz = (Number(list.finalPrice) / list.taxRate).toFixed(2);
      list.totalprice = (Number(list.proNumber) * Number(list.finalPrice)).toFixed(2);
    },
    // 根据订单数量以及成交价输入
    bindInputNum (row, index, type) {
      if (type == "CJJ") {
        row.proBenchmarkPrice = row.finalPrice;
      }
      row.jinejjz = (Number(row.finalPrice) / row.taxRate).toFixed(2);
      row.totalprice = (Number(row.proNumber) * Number(row.finalPrice)).toFixed(2);
      this.getCountData(index);
    },
    getQueryVariable (variable) {//获取参数
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
      }
      return (false);
    },
    isUpload (v) {
      console.log(v)
      if (v.length > 0) {
        //this.order.fileUrl = v[0].saveurl;
        let arrnew = []
        v.forEach(e => {
          arrnew.push(e.saveurl)
        })
        console.log(arrnew)
        this.order.fileUrl = arrnew
        console.log(this.order.fileUrl)
      } else {
        this.order.fileUrl = []
      }
    },
    sgIsUpload (v) {
      console.log('sgIsUpload', v)
      if (v.length > 0) {
        //this.order.fileUrl = v[0].saveurl;
        let arrnew = []
        v.forEach(e => {
          arrnew.push(e.saveurl)
        })
        console.log(arrnew)
        this.order.sgfileUrl = arrnew
        console.log(this.order.sgfileUrl)
      } else {
        this.order.sgfileUrl = []
      }
    },
    csIsUpload (v) {
      console.log('csIsUpload', v)
      if (v.length > 0) {
        //this.order.fileUrl = v[0].saveurl;
        let arrnew = []
        v.forEach(e => {
          arrnew.push(e.saveurl)
        })
        console.log(arrnew)
        this.order.csfileUrl = arrnew
        console.log(this.order.csfileUrl)
      } else {
        this.order.csfileUrl = []
      }
    },
    fileBack1 (v) {
      console.log(v)
      this.order.uploadFile = v.length;
    },
    //测试是否包含
    getNumber () {
      console.log(this.order)
      ss.OrderMainService.uploadCheck(this.order).then(res => {
        this.orderNu = res
      })
    },
    testDate () {
      var data = this.order
      console.log(this.order)
      ss.OrderMainService.checkDeliveryDay(data).then(res => {
        console.log(res)
        if (res.f == true) {
          console.log(res)
        } else {
          this.$message.error(res.msg);
        }
      })

    },
    //物流所需时间
    openReceivedTimefocus () {
      if (!this.openReceivedTimedisabled) {
        this.$msg.msge("请先选择的收货地址!");
      }
    },
    showzhezhao () {
      ss.salesList.toshow(this.toshow).then(rd => {
        console.log(rd)
        if (rd == false) {
          this.showOrhide = false;
        } else {
          this.showOrhide = true;
        }
      })
    },
    closeIt () {
      this.showOrhide = false;
      if (this.checked) {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          console.log(rd)
          this.showOrhide = false;
        })
      } else {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          console.log(rd)
          this.showOrhide = false;
        })
      }
    },
    nextcreateNx (i) {
      if (this.status == 1) {

        if (this.checked) {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        } else {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        }
      }
    },
    getOrder (id) {
      ss.OrderMainService.selectById(id).then(rd => {

        _.assign(this.order, rd.obj)
        this.ddlx = this.order.orderCategory + "," + (this.order.orderCategory1 || '');
        let type = this.order.orderCategory1;
        // 判断是否是经销商,经销商自己下单
        //当前登录人，就是经销商的话
        if (this._user.usertype == '1') {
          this.order.soldToCode = this._user.usercode;
          this.selectDailishang = false;
        }

        Promise.all([this.getShoudafang(this.order.soldToCode)]).then(() => {
          if (type == '1') {
            this.xmcode = this.order.orderProjectCode;
            //项目类型，一定有特价只有特价单，才有特价选择
            this.tejieshowflag = true;
          } else if (type == '7') {
            this.contractflag = false;
            this.xmcode = this.order.orderProjectCode;
          } else if (type == '4') {
            //    售后订单
            this.showshouhouflag = true;
            // 直接设置经销商
            this.selectDailishang = false;
          } else if (type == '3') {
            //    改制订单
            this.dingzhishowflag = true;
          } else if (type == '6' || type == '33') {
            //免费订单
            this.showIsFree = true;
            if (type == '33') {
              this.showIsFreeSh = true;
            }
            this.priceName = "成本价";
            //获取所有成本中心
            this.companyInfoList.forEach((obj) => {
              ss.OrderMainService.getCostCenterList({ companyCode: obj.code }).then(rd => {
                this['costList' + obj.code] = rd;
              })
            });


            //this.order.soldToCode = "A33";
          } else if (type == '5') {
            //样品机订单
            this.showSamplePro = true;
            this.showSampleHetong = true;
          } else if (type == '8') {
            //租赁订单
            this.showRent = true;
            this.xmcode = this.order.orderMainContract;
            ss.contractService.detail(this.order.orderMainContract).then(rd => {
              this.contract = rd.obj;
              this.order.zsyzq = rd.obj.zsyzq;
            })
          } else if (this.ddlx == '1,11') {
            //只有特价单，才有特价选择
            this.tejieshowflag = true;
          } else if (this.ddlx == '3,32') {
            this.showShcgmll = true;
          }
          if (rd.obj.products && rd.obj.products.length > 0) {
            // var wl = rd.obj.products[0];
            // if (this.ddlx == '1,15') {
            //   var tc = {};
            //   tc.packageCode = wl.packageCode;
            //   tc.packageName = wl.packageName;
            //   tc.sceneCode = wl.sceneCode;
            //   tc.sceneName = wl.sceneName;
            //   tc.lianqunCode = wl.lianqunCode;
            //   tc.lianqunName = wl.lianqunName;
            //   tc.proNumber = wl.packageNum;
            //   tc.proBenchmarkPrice = wl.packagePrice;
            //   tc.finalPrice = wl.packagePrice;
            //   tc.totalprice = wl.packageTotalPrice;
            //   tc.taxRate = wl.taxRate;
            //   tc.jinejjz = 0;
            //   tc.shuilv = wl.taxCode
            //   tc.gscode = wl.gscode;
            //   this.tcUnitNum = wl.packageUnitNum;
            //   this.tcGsCode = wl.gscode;
            //   this.tcData.gscode = wl.gscode;
            //   this.package.gscode = wl.gscode;
            //   this.zhidanGsCode = wl.gscode;
            //   this.packageTable.push(tc);
            //   // this.packageList = this.order.products;
            //   // this.cpdlcode = wl.proModelCode
            // }
            //如果是直单经销商，获取附件
            if (this.zhidanflag == '1') {
              uploaddown.listdownfile({ refid: this.testID, reftype: "NX_ZMFJ" }).then(rd => {
                this.fileList2 = rd.obj;
                this.idList.push(rd.obj.id);
                this.order.upload2.unshift("1");
              })
            }
          }

          var jjz = 0;
          //存在行项目
          if (rd.obj.products && rd.obj.products.length > 0) {

            this.getonesdfs(rd.obj.products)
            //加载完现金跟信贷，在插入行项目
            // Promise.all(this.companyInfoList.map((val, index) => { return this.getCredit(val.code) })).then(() => {
            //   rd.obj.products.forEach((obj) => {
            //     if (obj) {
            //       this.addProjectTcNew(obj);
            //       jjz += obj.jinejjz;
            //     }
            //     //判断是否冷库
            //     // ss.waixiao.isLk(obj.materialCode).then(rd => {
            //     //     this.lkFlag = rd.msg;
            //     // })
            //   })
            //   this.packageTable[0].jinejjz = jjz / this.packageTable[0].proNumber;
            //   //重新计算信贷
            //   this.companyInfoList.forEach((obj) => {
            //     if (this['order' + obj.code].creditid) {
            //       this.creditChange(this['order' + obj.code].creditid, obj.code);
            //     }
            //   })

            // })
          }
          if (rd.obj.isStandard == 2) {
            this.csFlag = true;
          }

        })
      })
    },
    async getonesdfs (products) {
      let taocanArr = products.filter(item => "packageName" in item);
      let cahnpinArr = products.filter(item => !("packageName" in item));
      var wl = taocanArr.length > 0 ? taocanArr[0] : cahnpinArr.length > 0 ? cahnpinArr[0] : null;
      if (wl) {
        this.tcUnitNum = wl.packageUnitNum;
        this.tcGsCode = wl.gscode;
        this.tcData.gscode = wl.gscode;
        this.package.gscode = wl.gscode;
        this.zhidanGsCode = wl.gscode;
      }
      // // 处理当前选了几个套餐
      const seen = new Set();
      taocanArr.forEach((item) => {
        if (!seen.has(item.packageName)) {
          seen.add(item.packageName);
          var tc = {};
          tc.packageCode = item.packageCode;
          tc.packageName = item.packageName;
          tc.sceneCode = item.sceneCode;
          tc.sceneName = item.sceneName;
          tc.lianqunCode = item.lianqunCode;
          tc.lianqunName = item.lianqunName;
          tc.proNumber = item.packageNum;
          tc.proBenchmarkPrice = item.packagePrice;
          tc.finalPrice = item.packagePrice;
          tc.totalprice = item.packageTotalPrice;
          tc.taxRate = item.taxRate;
          tc.shuilv = item.taxCode
          tc.jinejjz = 0;
          tc.gscode = item.gscode;
          this.packageTable.push(tc);
        }
      });
      console.log(this.packageTable, '//////////////lixiaotong')
      // 套餐产品数据
      this.packageList = taocanArr
      // 单品数据
      this.productList = cahnpinArr

      // 获取产品信息数据
      await this.getMapData(this.packageList);

      this.companyList.forEach((item, index) => {
        this.getCountData(index);
      });
    },
    viewpress (r) {
      this.showhistory = true;
    },
    backtolist () {
      this.$router.go(-1);
    },
    saveOrSubmit (v) {
      this.order.orderStatus = v
      if (v == '10') {
        this.order.submitflag = '暂存'
        this.order.newId = null
      } else if (v == '20') {
        this.order.submitflag = '提交'
        this.order.newId = null
      } else if (v == '30') {
        this.order.orderStatus = 20;
        this.order.newId = this.$route.query.ywid
        this.order.submitflag = '重新提报'
      }
      // orderPrice:null, // 订单总价
      //     orderPriceXj:0, // 订单现金占用
      //     orderPriceXjQk:0, // 订单现金欠款
      //     creditid:null, // 信贷id
      //     orderPriceXd:0, // 订单信贷占用
      //     orderNetWorth:null, // 订单净价值
      var flag = true;


      // 判断只有非元析的用户才校验直单附件
      if (!this.guanliren) {
        if (this.zhidanflag == '1') {
          if (this.fileList2.length < 1) {
            this.$msg.msge("直单用户下单必须上传直单附件！");
            return;
          }
        }
      }


      this.companyInfoList.forEach((obj) => {
        _.forEach(this['productlist' + obj.code], (value) => {
          if (this.showRent) {
            if (this.order.businessReason == "" || this.order.businessReason == null) {
              this.$msg.msge("请维护业务原因！");
              flag = false;

            }
            if (value.cwddh == "" || value.cwddh == null) {
              this.$msg.msge("请维护财务订单号！");
              flag = false;

            }
          }

          value.xdid = this['order' + obj.code].creditid
          value.totalpricermb = value.totalprice;
          value.costCenter = this.order['costCenter' + obj.code];
          this.order.orderPrice = new big(this.order.orderPrice || 0).plus(value.totalprice || 0);
          this.order.orderPriceRbm = new big(this.order.orderPriceRbm || 0).plus(value.totalprice || 0);

        });
      })

      // _.forEach(this.packageList, (value) => {

      //   if (this.showRent) {
      //     if (value.cwddh == "" || value.cwddh == null) {
      //       this.$msg.msge("请维护财务订单号！");
      //       flag = false;
      //     }
      //   }
      //   value.xdid = this.tcData.creditid
      //   value.totalpricermb = value.totalprice;
      //   value.packageTotalPrice = this.tcData.orderPrice
      //   this.order.costCenter = value.costCenter;


      //   // this.order.orderPrice = new big(this.order.orderPrice||0).plus(value.totalprice||0);
      //   this.order.orderPriceRbm = new big(this.order.orderPriceRbm || 0).plus(value.totalprice || 0);
      //   //套餐相关
      //   this.order.packageCode = value.packageCode;
      //   this.order.packageName = value.packageName;
      //   this.order.sceneCode = value.sceneCode;
      //   this.order.sceneName = value.sceneName;
      //   this.order.lianqunCode = value.lianqunCode;
      //   this.order.lianqunName = value.lianqunName;
      // });
      //每次提交或者暂存将值清零 防止累加 hyl
      this.order.orderPrice = 0;
      this.order.orderPriceRbm = 0;
      this.companyList.forEach(category => {
        // let packageTotalPrice = category.list.reduce((total, o) => total + Number(o.totalprice), 0).toFixed(2);
        category.list.forEach((item) => {
          item.totalpricermb = item.totalprice;

          item.packageTotalPrice = category.orderData.orderPrice
          // item.packageTotalPrice = this.companyList.reduce((total, item) => total + Number(item.orderData.orderPrice), 0);
          // this.order.costCenter = item.costCenter;
          this.order.orderPrice = Number(this.order.orderPrice) + Number(item.totalprice)
          this.order.orderPriceRbm = Number(this.order.orderPriceRbm || 0) + Number(item.totalprice);
          //套餐相关
          this.order.packageCode = item.packageCode;
          this.order.packageName = item.packageName;
          this.order.sceneCode = item.sceneCode;
          this.order.sceneName = item.sceneName;
          this.order.lianqunCode = item.lianqunCode;
          this.order.lianqunName = item.lianqunName;
        });
        // this.details.products = category.list
        // if (this.details.orderCategory1 == 6) {
        //   this.details['costCenter' + category.code] = category.costCenter
        // }
      });

      // this.order.orderPriceXj = new big(this.tcData.orderPriceXj || 0).toString();
      // this.order.orderPriceXd = new big(this.tcData.orderPriceXd || 0).toString();
      // this.order.orderNetWorth = this.tcData.orderNetWorth || '0';


      // this.order.products = [...this.packageList];
      let productsArr = this.companyList.reduce((accumulator, currentObject) => {
        return accumulator.concat(currentObject.list);
      }, []);

      this.order.products = [...productsArr, ...this.productList]
      this.order.orderPriceXj = this.order.products.reduce((total, item) => total + Number(item.totalprice), 0);
      //计算所有订单净价值
      this.order.orderNetWorth = this.order.products.reduce((total, item) => total + Number(item.jinejjz), 0).toFixed(2);

      this.order.products2 = this.productlist2;

      // 判断只有非元析用户套餐备注才这么处理
      if (!this.guanliren) {
        for (var i = 0; i < this.packageList.length; i++) {
          this.packageList[i].note1 = this.remark;
        }
      }
      if (flag) {
        if (this.order.submitflag == '提交' || this.order.submitflag == '重新提报') {
          //免费订单校验
          var freeflag = true;
          var companyFlag = true;

          if (this.showIsFree) {
            this.$refs['form0'].validate((valid0) => {
              freeflag = valid0;
            });
            //必填校验
            this.companyInfoList.forEach((obj) => {
              if (this['productlist' + obj.code].length > 0) {
                //因为el-form ref是动态生成的 会变成数组所以加[0]
                this.$refs['form' + obj.code][0].validate((valid0) => {
                  if (!valid0) {
                    companyFlag = valid0;
                    return false;
                  }
                });
              }
            })

          }

          this.$refs['form1'].validate((valid1) => {
            if (valid1 && freeflag && companyFlag) {
              this.$msg.confirm("确认提交？", () => {
                // console.log('我在这儿呀', this.order.orderPriceRbm,'4234324', this.order.orderPrice);
                this.submitForm();
              })
            } else {
              this.$msg.msge("请完善基本信息后提交");
              return;
            }
          });
        } else {
          this.submitForm();
        }
      }

    },
    submitForm () {
      if (this.submitChongfuFlag) {

        if (this.order.tuihyydes == '' || this.order.tuihyydes == null) {
          this.order.tuihyydes = '检测'
        }
        // this.order.ydgFlag = this.ydgFlag;
        //标准订单和特殊订单
        if (this.order.category1Name == '标准订单' || this.order.category1Name == '特价订单') {
          //检测是否需要上传附件
          ss.OrderMainService.uploadCheck(this.order).then(res => {
            this.orderNu = res
            if (this.orderNu == 1 && this.order.isStandard == 1) {
              this.$message.error('此产品为冷库产品，请上传方案图纸和施工确认单');
              //
            } else if (this.orderNu == 1 && this.order.isStandard == 2) {
              this.$message.error('此产品为冷库产品，请上传方案图纸,施工确认单和投标参数');
            } else {
              ss.OrderMainService.checkDeliveryDay(this.order).then(res => {
                console.log(res)
                if (res.f == true) {
                  console.log(res)
                  this.submitChongfuFlag = false;
                  ss.OrderMainService.saveOrSubmit(this.order).then(rd => {
                    this.submitChongfuFlag = true;
                    if (rd.f) {
                      if (this.order.submitflag == '提交' || this.order.submitflag == '重新提报') {
                        this.$msg.msgs("提交成功！")
                        this.$router.push({ path: '/dingd/dingdmainlist' })
                      } else {
                        this.$msg.msgs("暂存成功！")
                      }
                    } else {
                      this.$msg.msge(rd.msg);
                    }
                  })
                } else {
                  this.$message.error(res.msg);
                }
              })
            }

          })


        } else {
          this.submitChongfuFlag = false;
          //传一下公司
          this.order.companycode = this.tcGsCode;
          // 非标准订单，非特殊订单
          ss.OrderMainService.saveOrSubmit(this.order).then(rd => {
            this.submitChongfuFlag = true;
            if (rd.f) {
              if (this.order.submitflag == '提交' || this.order.submitflag == '重新提报') {
                this.$msg.msgs("提交成功！")
                this.$router.push({ path: '/dingd/dingdmainlist' })
              } else {
                this.$msg.msgs("暂存成功！")
              }
            } else {

              this.$msg.msge(rd.msg);
            }
          })
        }
      } else {
        this.$msg.msge("重复点击提交，请稍后操作！");
      }
    },
    resaveOrSubmit (v) {
      this.saveOrSubmit(30);
      // this.order.orderStatus = v
      // this.$msg.confirm("确认提交？", () => {
      //     this.order.submitflag = '重新提报'
      //     ss.OrderMainService.saveOrSubmit(this.order).then(rd => {
      //         this.$router.push({path: '/dingd/dingdmainlist'})
      //     })
      // })
    },
    getShoudafang (usercode) {
      if (!usercode) {
        if(this.guanliren){
          this.order.receivedTime = this.$util.formatDate(this.$util.addDays(new Date(), 6))
        }
        return "";
      }
      return ss.selectUserAgent.getOneShoudf(this.order.soldToCode).then(rd => {
        this.choseshoudf(rd, true);
      })
    },
    //查询用户，用户余额，所有信贷
    async getCredit (gscode) {
      var params = {};
      console.log(this['productlist' + gscode])
      console.log(_.map(this['productlist' + gscode], "proModelCode"))
      //列表中的第一个的产品大类
      var cpdl = _.uniq(_.map(this['productlist' + gscode], "proModelCode"));
      if (cpdl.length == 1) {
        params.cpdlcode = cpdl[0];
      }
      params.salegroupcode = gscode;
      params.usercode = this.order.soldToCode;
      // console.log(params)
      return await ss.OrderMainService.getUserMoneyCredit(params).then(rd => {
        console.log("信贷1", rd)
        this['order' + gscode].creditData = rd.xd;
        this['order' + gscode].xianjye = rd.xj ? (rd.xj.cashBalance || 0) : 0;
        console.log("this['order' + gscode]", this['order' + gscode])
        if (this.tcGsCode) {
          if (this.tcGsCode == gscode) {
            this.tcData.gscode = gscode;
            this.tcData.creditData = rd.xd;
            this.tcData.xianjye = rd.xj ? (rd.xj.cashBalance || 0) : 0;
            // this.tcData.creditid
            this.tcData.creditid = this.tcData.creditData.length > 0 ? _.first(this.tcData.creditData).id : null;
            this.tcData.orderPriceXd = 0;
            this.package.gscode = gscode;
            this.package.creditData = rd.xd;
            this.package.xianjye = rd.xj ? (rd.xj.cashBalance || 0) : 0;
            // this.package.creditid
            this.package.creditid = this.package.creditData.length > 0 ? _.first(this.package.creditData).id : null;
            this.package.orderPriceXd = 0;

          }
        }
      })
    }
    ,
    // 选择具体的信贷
    creditChange (v, gscode) {
      console.log("默认选中信贷", v, gscode)
      if (v) {
        var orderje = this.tcData.orderPrice;
        var xd = _.find(this.tcData.creditData, { id: v })
        var xdye = xd.quota;
        //用户的现金余额
        var xjye = this.tcData.xianjye;

        if (xjye > 0) {
          if (xjye >= orderje) {
            this.tcData.creditid = null;
            this.tcData.orderPriceXd = 0;
          } else {
            //现金+信贷>订单金额
            if (xdye + xjye > orderje) {
              this.tcData.orderPriceXd = orderje - xjye;
            } else {
              if (orderje - xjye < xdye) {
                this.tcData.orderPriceXd = orderje - xjye;
              } else {
                this.tcData.orderPriceXd = xdye;
              }
            }
          }
        } else {
          //信贷金额，大于订单总额
          if (xdye >= orderje) {
            this.tcData.orderPriceXd = orderje;
          } else {
            //订单减掉现金余额
            this.tcData.orderPriceXd = xdye;
          }
        }
      } else {
        this.tcData.creditid = null;
        this.tcData.orderPriceXd = 0;
      }
      // this.tcData = this['order' + gscode];
    },
    //定制改变
    changeDingzhi (row) {
      if (row.extraDes) {
        row.isCustommed = 1;
      } else {
        row.isCustommed = 0;
        row.extraPrice = null;
        row.extraDes = null;
      }
    },
    //特价改变
    changeTejia (scode, row) {
      console.log('特价改变', scode, row)
      if (row.specialOfferCode) {
        const tjobj = _.find(row.tjlist, { tjdtid: row.specialOfferCode })
        row.specialPrice = tjobj.tejia;
        row.specialPriceNum = tjobj.sysl;
        row.tjid = tjobj.tjid;
        row.tjdtid = tjobj.tjdtid;
        /*                    if(this.ddlx == '1,11'){
                              row.proBenchmarkPrice = tjobj.dingjia;//产品基准价
                            }*/
        if (this.ddlx == '1,11' || this.ddlx == '1,1') {
          row.proBenchmarkPrice = tjobj.dingjia;//产品基准价
          //设置bom信息
          row.bomId = tjobj.bomId;
          row.isBom = tjobj.bomId ? 1 : 0;

        }
      } else {
        row.specialOfferCode = null;
        row.specialPrice = null;
        row.specialPriceNum = null;
        row.tjid = null;
        row.tjdtid = null;
        /*                    if(this.ddlx == '1,11'){
                              row.proBenchmarkPrice = 0;//产品基准价
                            }*/
        if (this.ddlx == '1,11' || this.ddlx == '1,1') {
          row.proBenchmarkPrice = 0;//产品基准价
        }
      }
    },

    changeArea (query) {
      console.log("接受到的参数", query);
      //根据选择的销售区域带出对应的渠道

      let value = {
        usercode: this.order.soldToCode,
        areaCode: query
      }
      ss.OrderMainService.getChannelByArea(value).then(rd => {
        console.log(rd);
        this.customerChannelListFilter = rd.msg;
        console.log(this.salesregionNameListFilter)
        if (this.customerChannelListFilter.length > 0) {
          //    this.order.customerChannelCode = null;
        } else {
          this.showshdfdialog = false
          this.$msg.msge("该售达方没有维护客户渠道信息，请联系管理员！")
          return;
        }
      })
      this.companyInfoList.forEach((obj) => {
        this['productlist' + obj.code] = [];
      })
      this.order.customerChannelCode = '';
    },
    //清空已选产品列表
    cleanOrder () {
      console.log('客户渠道发生变化!')
      if (this.ddlx == '1,4') {
        return;
      }
      this.companyInfoList.forEach((obj) => {
        this['productlist' + obj.code] = [];
      })
      this.productlist2 = [];

      this.companyList = [];
      this.packageTable = [];
      this.packageList = [];
      this.productList = [];
    },

    //选择售达方
    openShoudf () {
      this.showshdfdialog = true;
    },
    choseshoudf (obj, changeflag) {

      console.log('1234-->', obj)
      //                设置客户渠道，
      //                 this.customerChannelListFilter = _.split(obj.khqd,",");
      //                 if(this.customerChannelListFilter.length>0){
      //                     this.order.customerChannelCode=obj.khqd;
      //                 }else{
      //                     this.showshdfdialog = false
      //                     this.$msg.msge("该售达方没有维护客户渠道信息，请联系管理员！")
      //                     return;
      //                 }

      //直单用户flag
      this.zhidanflag = obj.zhidanflag;
      this.companycodes = obj.companycodeBas;
      this.isBlood = obj.isBlood;
      //是否直单用户并且内销标准订单 可选择公司
      console.log("类型", this.ddlx);
      if (this.zhidanflag == '1') {
        this.chooseGscode = true;

        //判断当前用户可选择的公司
        this.companyInfoList.forEach((obj) => {
          if (this.companycodes.indexOf(obj.code) != -1) {
            this.zhidanCompanycode.push({
              key: obj.code,
              value: obj.name
            });
          }
        })

        //0HL0 特殊处理
        if (this.companycodes.indexOf("0HL0") != -1) {
          this.zhidanCompanycode.push({
            key: "9370",
            value: "青岛海尔生物医疗科技有限公司(9370)"
          });
        }


        //如果都没签约9370或9390 提示错误
        if (this.companycodes.length <= 0) {
          this.showshdfdialog = false
          this.$msg.msge("该直单用户没有签约公司，请联系管理员！")
          return;
        }

        //租赁订单自己选
      } else {
        this.chooseGscode = false;
      }


      console.log("公司代码：" + this.companycodes);
      console.log("是否血站渠道：" + this.isBlood);

      // 设置客户渠道，
      this.customerChannelListFilter = _.filter(this.customerChannelList, (o) => {
        return _.split(obj.khqd3 || '', ",").includes(o.code);
      });
      this.salesregionNameListFilter = _.filter(this.salesregionNameList, (o) => {
        return _.split(obj.salesregion || '', ",").includes(o.code);
      });
      if (this.customerChannelListFilter.length > 0) {
        //    this.order.customerChannelCode = null;
      } else {
        this.showshdfdialog = false
        this.$msg.msge("该售达方没有维护客户渠道信息，请联系管理员！")
        return;
      }

      // 清空物料
      if (this.order.soldToCode != obj.usercode) {
        this.productlist2 = [];
        this.companyList = []
        this.packageTable = [];
        this.packageList = [];
        this.productList = [];
      }
      //如果是A33客户（青岛海尔特种电器有限公司一次性客户） 此字段应于判断样品机订单 A33客户的打折级别
      if (obj.usercode == 'A33') {
        this.isA33 = true;
      } else {
        this.isA33 = false;
      }
      this.order.soldToName = obj.username;
      this.order.soldToCode = obj.usercode;
      this.order.soldToAreaCode = obj.area;
      this.order.soldToAreaName = obj.areaname;
      this.salesregionNameListFilter = _.filter(this.salesregionNameList, (o) => {
        return _.split(obj.salesregion || '', ",").includes(o.code);
      });
      this.order.gjmytk = obj.gjmytk; //国际贸易条款
      this.order.fktj = obj.fktj; //付款条件
      this.order.currencyCode = (changeflag ? this.order.currencyCode : obj.currency) || 'CNY';
      this.showshdfdialog = false;

      // this.order.customerChannelCode = null;

    },




    wlToProject (bom) {
      console.log(bom, '11111111111')
      // let obj = this.packageTable[0] || {};
      // console.log(obj, '222222222222')
      var wl = {};
      wl.id = this.$util.getUuid();
      wl.materialCode = bom.matecode; //产品编码
      wl.materialName = bom.matedes; //产品名称
      wl.proModelCode = bom.cpdlcode; //产品型号编码
      wl.proModelName = bom.cpdlname; //产品型号名称
      wl.proNumber = 0
      wl.tcProNum = 0
      wl.extraPrice = null; // 定制加价
      wl.extraDes = null; // 定制需求
      wl.cwddh = null;
      wl.proType = bom.protype; //自产还是oem

      wl.fromtype = bom.fromtype;
      wl.cpz = bom.cpz; //产品组
      wl.dwcode = bom.dwcode; //单位
      wl.dwname = bom.dwname; //单位
      wl.currencyCode = bom.currency; //币种编码

      wl.cgprice = bom.cgprice || '' //采购价
      wl.cgmll = bom.cgmll || '' //采购毛利率
      wl.tjlist = bom.tjlist || '' //特价list
      wl.expoPrice = bom.expoPrice || '';
      //样品机库位是不是单独取?
      wl.factory = bom.factory;

      wl.cpdlcode = bom.cpdlcode;
      //套餐单个产品的成交价
      wl.tcProPrice = 0;
      wl.proBenchmarkPrice = bom.jizhj
      //成交价
      wl.finalPrice = bom.jizhj || 0
      // wl.totalprice = (Number(bom.finalPrice) * Number(bom.num)).toFixed(2);
      // wl.taxCode = obj.shuilv;
      //税率
      // if (obj.shuilv == "JC") {
      //   wl.taxRate = 1.13;
      //   wl.taxCat = 3; //税分类
      // } else if (obj.shuilv == "JQ") {
      //   wl.taxRate = 1.06;
      //   wl.taxCat = 7; //税分类
      // } else if (obj.shuilv == "J5") {
      //   wl.taxRate = 1.09;
      //   wl.taxCat = 6; //税分类
      // } else {
      //   this.$msg.msge("税率查询有误！");
      //   return;
      // }
      if(bom.fromtype == 'fw' || bom.isFw == '1'){
        if (bom.taxCat == '3') {
          wl.taxCode = 'JC';
        } else if (bom.taxCat == '7') {
          wl.taxCode = 'JQ';
        } else if (bom.taxCat == '0') {
          wl.taxCode = 'J0';
        } else if (bom.taxCat == '6') {
          wl.taxCode = 'J5';
        }
        //税率
        if (bom.taxCat == '2' || bom.taxCat == '3' || bom.taxCat == '4') {
          wl.taxRate = 1.13;
        } else if (bom.taxCat == '7') {
          wl.taxRate = 1.06;
        } else {
          wl.taxRate = 1;
        }
      }

      if (bom.taxCat != null && bom.taxCat != '') {
        wl.taxCat = bom.taxCat;//税分类
      } else {
        uni.showToast({
          title: '税分类不能为空！',
          icon: 'none',
          duration: 2000
        })
        return;
      }
      //税率
      if (wl.taxCat == '2' || wl.taxCat == '3' || wl.taxCat == '4') {
        wl.taxRate = 1.13;
      } else if (wl.taxCat == '7') {
        wl.taxRate = 1.06;
      } else {
        wl.taxRate = 1;
      }
      wl.gscode = bom.companycode; //公司编码
      //套餐相关
      // wl.lianqunName = obj.lianqunName;
      // wl.lianqunCode = obj.lianqunCode;
      // wl.sceneCode =
      //   obj.sceneCode + (obj.childSceneCode ? "#" + obj.childSceneCode : "");
      // wl.sceneName =
      //   obj.sceneName + (obj.childSceneName ? "#" + obj.childSceneName : "");

      // wl.packageName = obj.packageName;
      // wl.packageNum = 1
      // wl.packageCode = obj.packageCode;
      // wl.packagePrice = obj.packagePrice;
      // wl.isWhole = obj.isWhole;
      wl.jishu = bom.jishu;
      wl.xiaoe = bom.xiaoe;
      wl.lianqun = bom.lianqun;
      if (bom.isTj == 1) {
        wl.specialOfferCode = bom.specialOfferCode;
        wl.specialPrice = bom.finalPrice;
      }
      wl.oemDesc = bom.oemDesc;
      wl.tjlist = []
      wl.yidishpyj = null
      wl.orderField = 1
      wl.jinejjz = (Number(wl.finalPrice) / Number(wl.taxRate)).toFixed(2).toString();
      wl.totalprice = (Number(wl.finalPrice) * Number(wl.proNumber)).toFixed(2).toString();
      if(this.guanliren&wl.proType=='OEM'){
        //根据产品种类判断是不是直发,如果产品层级
        if(bom.productHierarchy != null && bom.productHierarchy != ''){
          if(bom.productHierarchy.includes("YX1E33") || bom.productHierarchy.includes("YX1J26") ||bom.productHierarchy.includes("YX1J27")){
            wl.zhifakufa = 1
          }else {
            wl.zhifakufa = 2
          }
        }else {
          wl.zhifakufa = 2
        }
      }
      console.log(wl, '333333333')
      return wl;
    },
    //选择地址
    selectAreadialog () {
      this.showdizhiflag = true;
    },
    choseDizhi (obj) {

      console.log("选中的地址", obj)
      this.order.addressCode = obj.id;
      this.order.areaId = obj.id;
      this.order.toAddress = obj.quobj.namepath;
      if (obj.zhenobj) {
        // this.order.toAddress = obj.zhenobj.namepath;
        obj.addrdetail = obj.zhenobj.name + "/" + obj.addrdetail;
      }
      this.order.toAddress = this.order.toAddress + "##" + obj.addrdetail

      this.order.toProvincesCode = obj.shengobj.code;
      this.order.toProvincesName = obj.shengobj.name;

      this.order.toCityCode = obj.shiobj.code;
      this.order.toCityName = obj.shiobj.name;

      this.showdizhiflag = false;


      //清空时间
      this.order.receivedTime = null;
      this.openReceivedTimedisabled = false;
      //根据地址，获取预计收货时间
      // ss.OrderMainService.getSendDays(obj.qu).then(rd => {
      //     console.log(rd);
      //     this.startDateLimit = _.assign({}, this.startDateLimit, {
      //         disabledDate: (time) => {
      //             return time.getTime() < new big(rd).plus(2).times(24 * 60 * 60 * 1000).plus(Date.now()).toString()
      //         }
      //     })
      // })
    },

    //直单用户修改公司 hyl
    chooseGsCode (code) {

      for (var i = 0; i < this.packageTable.length; i++) {
        this.packageTable[i].gscode = code;
      }
      for (var i = 0; i < this.packageList.length; i++) {
        this.packageList[i].gscode = code;
      }
      this.getCredit(code);

      //清空套餐信息
      this.packageTable = [];
      this.packageList = [];
    },

    isStandardChange () {
      if (this.order.isStandard == 2) {
        this.csFlag = true;
      } else if (this.order.isStandard == 1) {
        this.csFlag = false;
      }
    },

    showPackage () {
      if (!this.order.soldToCode) {
        this.$msg.msge("请先选择售达方信息！")
        return;
      }
      if (this.order.orderCategory1 != 7 && this.order.orderCategory1 != 9 && this.order.orderCategory1 != 8 && this.order.orderCategory1 != 6 && !this.order.salesregion) {
        this.$msg.msge("请先选择销售区域！")
        return;
      }
      if (this.order.orderCategory1 != 7 && this.order.orderCategory1 != 9 && !this.order.customerChannelCode) {
        this.$msg.msge("请先选择客户渠道！")
        return;
      }
      this.packageFlag = true;
      this.tcFlag = true;
    },

    async chosePackage (obj) {

      // if (this.packageTable.length > 1) {
      //   this.$msg.msge("只能选择一个套餐！")
      //   return;
      // }
      console.log('99999999%', obj)
      var tc = {
        ...obj
      };
      tc.id = obj.id;
      tc.packageCode = obj.packageCode;
      tc.packageName = obj.packageName;
      tc.sceneCode = obj.sceneCode + (obj.childSceneCode ? "#" + obj.childSceneCode : "");
      tc.sceneName = obj.sceneName + (obj.childSceneName ? "#" + obj.childSceneName : "");
      tc.lianqunCode = obj.lianqunCode;
      tc.lianqunName = obj.lianqunName;
      // tc.proNumber = packageInfo.num;
      tc.proNumber = 0;
      tc.proBenchmarkPrice = obj.packagePrice;
      tc.finalPrice = obj.packagePrice;
      tc.totalprice = 0;
      tc.shareModelCode = obj.shareModelCode ? obj.shareModelCode : "";
      tc.shareModelName = obj.shareModelName ? obj.shareModelName : "";
      var taxrate = 0;
      //税率
      if (taxrate == '2' || taxrate == '3' || taxrate == '4') {
        tc.taxRate = 1.13;
      } else if (taxrate == '7') {
        tc.taxRate = 1.06;
      } else {
        tc.taxRate = 1;
      }
      // if (this.packageTable.length >= 1) {
      //   this.$msg.msge("一笔套餐订单只能选择一个套餐下单!");
      //   return;
      // } else {

      // }
      this.packageTable.push(tc);


      await this.wlToProjectTc(obj);

      this.packageTable = await this.uniqueList(this.packageTable)
      // this.packageList = await this.mergedList(this.packageList)
      console.log(this.packageTable, "数据");
      console.log(this.packageList, "产品");
      this.getMapData(this.packageList)

      //如果1S00公司
      // if ((obj.companycode == '1S00') && this.hhxmList.length == 0) {
      //   this.isHh = true;
      //   //查询厚宏项目合同
      //   ss.contractService.getHhxmContract(this.order.soldToCode).then(rd => {
      //     this.hhxmList = rd.msg;
      //   })
      // }

      //如果44u0/45k0公司
      if (obj.companycode == '44U0' || obj.companycode == '45K0') {
        this.isYx = true;
      }
      this.packageFlag = false;
    },
    // 套餐去重
    uniqueList (originalist) {
      const temp = {};
      return originalist.reduce((acc, current) => {
        if (!temp[current.id]) {
          temp[current.id] = true;
          acc.push({ ...current }); // 浅拷贝避免引用问题
        }
        return acc;
      }, []);
    },
    // 重新合并数组
    mergedList (originalArray) {

      // 使用 reduce 进行归并操作
      const temp = originalArray.reduce((acc, current) => {
        console.log("originalArray,",originalArray)
        console.log("acc,",acc)
        console.log("current,",current)


        const key = current.materialCode; // 以 id 作为唯一标识符
        if (acc[key]) {
          // 合并 value 字段（确保类型为数字）
          acc[key].proNumber += Number(current.proNumber) || 0;
        } else {
          // 创建新对象，避免引用原始数据
          acc[key] = { ...current };
          acc[key].proNumber = Number(current.proNumber) || 0; // 确保 value 是数字
        }
        return acc;
      }, {});

      return Object.values(temp); // 将对象转换为数组
    },
    // 处理产品数据
    async getMapData (data) {
      const grouped = data.reduce((acc, item) => {
        if (!acc[item.packageCode]) {
          acc[item.packageCode] = [];
        }
        acc[item.packageCode].push(item);
        return acc;
      }, {});
      this.companyList = Object.keys(grouped).map((code, index) => ({
        code: code,
        name: grouped[code][0].packageName,
        list: this.mergedList(grouped[code]),
        orderData: {
          orderPrice: 0, // 订单总价
          xianjye: 0, //现金余额
          orderPriceXj: 0, // 订单现金占用
          orderPriceXjQk: 0, // 订单现金欠款
          orderNetWorth: 0, // 订单净价值
        },
      }));
      // 获取数据后计算当前的净价值以及总价
      this.companyList.forEach((item) => {
        item.list.forEach((val) => {
          val.jinejjz = (Number(val.finalPrice) / Number(val.taxRate)).toFixed(2).toString();
          val.totalprice = (Number(val.proNumber) * Number(val.finalPrice)).toFixed(2).toString();
        });
      });
      this.companyList.forEach((item, index) => {
        this.getCountData(index);
      });
      console.log(this.companyList, "处理完的最终数据");
    },
    // 计算相关数据
    getCountData (index) {
      // 计算订单总价
      this.companyList[index].orderData.orderPrice = this.companyList[index].list.reduce((total, item) => total + Number(item.totalprice), 0).toFixed(2);
      // 计算现金占用
      this.companyList[index].orderData.orderPriceXj = (Number(this.companyList[index].orderData.orderPrice) || 0).toFixed(2);
      // 计算现金欠款
      this.companyList[index].orderData.orderPriceXjQk = Math.abs(
        Number(this.companyList[index].orderData.xianjye) -
          Number(this.companyList[index].orderData.orderPriceXj) >
          0
          ? 0
          : Number(this.companyList[index].orderData.xianjye) -
          Number(this.companyList[index].orderData.orderPriceXj)
      ).toFixed(2);
      // 净价值
      this.companyList[index].orderData.orderNetWorth = this.companyList[index].list.reduce((total, item) => total + Number(item.jinejjz), 0).toFixed(2);
    },
    wlToProjectTc (obj) {
      //判断产品是否有对应的定价信息
      for (var i = 0; i < obj.bomDetailList.length; i++) {
        var wl = {};
        var bom = obj.bomDetailList[i];
        console.log(i, bom)
        // this.cpdlcode = bom.proModelCode
        wl.id = this.$util.getUuid();
        wl.materialCode = bom.prodcode;//物料编码
        wl.materialName = bom.promodel;//物料名称
        wl.proModelCode = bom.proModelCode;//产品型号编码
        wl.proModelName = bom.proModelName;//产品型号名称
        wl.proNumber = Number(bom.num) * Number(obj.packageNum);
        wl.tcProNum = bom.num;
        wl.extraPrice = null; // 定制加价
        wl.extraDes = null; // 定制需求
        wl.cwddh = null;
        wl.proType = bom.protype; //自产还是oem
        // wl.totalprice = 0;//产品总价
        wl.finalPrice = 0;

        wl.fromtype = bom.fromtype;
        wl.cpz = bom.cpz; //产品组
        wl.dwcode = bom.dwcode;//单位
        wl.dwname = bom.dwname;//单位
        wl.currencyCode = bom.currency;//币种编码

        wl.cgprice = bom.cgprice; //采购价
        wl.cgmll = bom.cgmll; //采购毛利率
        wl.tjlist = bom.tjlist;//特价list
        wl.expoPrice = bom.expoPrice;
        //样品机库位是不是单独取?
        wl.factory = bom.factory;

        wl.cpdlcode = bom.cpdlcode;
        //套餐单个产品的成交价
        wl.tcProPrice = bom.finalPrice;
        wl.proBenchmarkPrice = bom.proPrice;
        //成交价
        wl.finalPrice = bom.finalPrice;
        // wl.totalprice = new big(bom.finalPrice).times(new big(bom.num)).toFixed(2);
        wl.taxCode = obj.shuilv;
        //税率
        if (obj.shuilv == 'JC') {
          wl.taxRate = 1.13;
          wl.taxCat = 3;//税分类
        } else if (obj.shuilv == 'JQ') {
          wl.taxRate = 1.06;
          wl.taxCat = 7;//税分类
        } else if (obj.shuilv == 'J5') {
          wl.taxRate = 1.09;
          wl.taxCat = 6;//税分类
        } else {
          this.$msg.msge("税率查询有误！");
          return;
        }
        //免费订单都传9390
        if (this.ddlx == '1,6' || obj.cpdlcode == 'ND1') {
          wl.gscode = "9390";
        } else {
          wl.gscode = obj.companycode; //公司编码
        }

        this.tcGsCode = wl.gscode;
        this.zhidanGsCode = wl.gscode;

        //套餐相关
        wl.lianqunName = obj.lianqunName;
        wl.lianqunCode = obj.lianqunCode;
        wl.sceneCode = obj.sceneCode + (obj.childSceneCode ? "#" + obj.childSceneCode : "");
        wl.sceneName = obj.sceneName + (obj.childSceneName ? "#" + obj.childSceneName : "");

        wl.packageName = obj.packageName;
        wl.packageNum = obj.packageNum
        wl.packageCode = obj.packageCode;
        wl.packagePrice = obj.packagePrice;
        wl.isWhole = obj.isWhole;
        wl.jishu = bom.jishu;
        wl.xiaoe = bom.xiaoe;
        wl.lianqun = bom.lianqun;
        if (bom.isTj == 1) {
          wl.specialOfferCode = bom.specialOfferCode;
          wl.specialPrice = bom.finalPrice;
        }
        wl.oemDesc = bom.oemDesc;
        wl.tjlist = []
        if(this.guanliren&wl.proType=='OEM'){
          //根据产品种类判断是不是直发,如果产品层级
          if(bom.productHierarchy != null && bom.productHierarchy != ''){
            if(bom.productHierarchy.includes("YX1E33") || bom.productHierarchy.includes("YX1J26") ||bom.productHierarchy.includes("YX1J27")){
              wl.zhifakufa = 1
            }else {
              wl.zhifakufa = 2
            }
          }else {
            wl.zhifakufa = 2
          }
        }
        this.addProjectTc(wl)
      }
      // //获取信贷信息
      // Promise.all(this.companyInfoList.map((val, index) => { return this.getCredit(val.code) })).then(() => {
      //   this.companyInfoList.forEach((obj) => {
      //     this['order' + obj.code].creditid = this['order' + obj.code].creditData.length > 0 ? _.first(this['order' + obj.code].creditData).id : null;
      //     this['order' + obj.code].orderPriceXd = 0;
      //   })
      // })
    },
    addProjectTc (obj) {
      var alllist = _.clone([...this.packageList]);
      // 不是直单的用户，如果下液氮罐的话，必须单独下单
      if (this.zhidanflag != '1' && obj.proModelCode == 'ND1' && (this.ddlx != '1,4' && this.ddlx != '1,6' && this.ddlx != '1,12')) {
        // 看看产品列表里有没有其他产品
        for (var i = 0; i < alllist.length; i++) {
          var one = alllist[i];
          if (one.proModelCode != 'ND1') {
            this.$msg.msge("液氮罐系列产品不能跟其他产品一起下单，请单独下单！");
            return;
          }
        }
        this.ydgFlag = true;
      }
      if (this.zhidanflag != '1' && obj.proModelCode != 'ND1' && (this.ddlx != '1,4' && this.ddlx != '1,6' && this.ddlx != '1,12')) {
        // 看看产品列表里有没有其他产品
        for (var i = 0; i < alllist.length; i++) {
          var one = alllist[i];
          if (one.proModelCode == 'ND1') {
            this.$msg.msge("液氮罐系列产品不能跟其他产品一起下单，请单独下单！");
            return;
          }
        }
        this.ydgFlag = false;
      }

      if (!this.order['costCenter' + obj.gscode]) {
        this.order['costCenter' + obj.gscode] = obj.costCenter || null;
      }
      //直单用户的话，全部下到9390
      if (this.zhidanflag == '1') {
        //根据用户选择公司编码 hyl
        obj.gscode = this.zhidanGsCode;
      }
      //如果是空的默认44u0
      if(null == obj.gscode || ''==obj.gscode){
        obj.gscode == '44U0'
      }
      obj.note1 = null;
      obj.jinejjz = (Number(obj.finalPrice) / Number(obj.taxRate)).toFixed(2).toString();
      obj.totalprice = (Number(obj.finalPrice) * Number(obj.proNumber)).toFixed(2).toString();
      this.packageList.push(obj);
      this.package.creditid = obj.xdid;
      this.package.gscode = obj.gscode;
      this.tcData.creditid = obj.xdid;
      this.tcData.gscode = obj.gscode;
      //测试
      // this['productlist' + obj.gscode].push(obj);
      // console.log("this.productList",this['productlist' + obj.gscode])
      // this['order' + obj.gscode].creditid = obj.xdid;
      this.tcData = this.package;

    },
    //编辑功能用添加行项目
    addProjectTcNew (obj) {
      this.packageList.push(obj);
      this.package.creditid = obj.xdid;
      this.package.gscode = obj.gscode;
      this.tcData.creditid = obj.xdid;
      this.tcData.gscode = obj.gscode;
      this['order' + obj.gscode].creditid = obj.xdid;
      this['order' + obj.gscode].orderPrice = obj.packageTotalPrice;
      //测试
      // this['productlist' + obj.gscode].push(obj);
      // console.log("this.productList",this['productlist' + obj.gscode])
      // this['order' + obj.gscode].creditid = obj.xdid;
      // this.tcData = this.package;
    },
    //套餐数量改变之后,同时改变套餐明细中对应的产品数量
    changeProNum (v) {
      for (var i = 0; i < this.packageList.length; i++) {
        var taocan = this.packageList[i];
        if (taocan.packageCode == v.packageCode) {
          if (v.proNumber >= 1) {
            taocan.proNumber = new big(taocan.tcProNum || 0).times(new big(v.proNumber || 0)).toString();
            taocan.totalprice = new big(taocan.proNumber || 0).times(new big(taocan.finalPrice || 0)).toFixed(2).toString();
            taocan.jinejjz = big(taocan.finalPrice).div(taocan.taxRate).toFixed(2).toString();
            taocan.packageNum = v.proNumber;
            taocan.packageTotalPrice = v.totalprice;
          }
        }
      }

    },
    //删除套餐同时删除套餐明细
    deleteTc (row) {
      //先删除套餐信息
      var id = row.id;
      this.$msg.confirm("确认删除？", () => {
        // this.packageTable = _.reject(this.packageTable, {'id': id});
        this.packageTable = [];
        this.packageList = [];
      })
      // 先遍历list里面的每一个元素，对比item与每个元素的id是否相等，再利用splice的方法删除
      // for (var key in this.packageList) {
      //     if (this.packageList[key].packageCode === row.packageCode) {
      //         this.packageList.splice(key, 1)
      //     }
      // }
    },
    // 选择产品
    bindChoseWuliao (objs) {
      console.log(objs)
      var product = [];
      for (var i = 0; i < objs.length; i++) {
        var addwl = objs[i];
        var wl = this.wlToProject(addwl);
        product.push(wl);
      }
      this.productList = this.productList.concat(product);
      // console.log("this.packageList", this.packageList)
      this.showwuliaodialog = false;
    },
    // 添加产品
    addProducts () {
      if (!this.order.soldToCode) {
        this.$msg.msge("请先选择售达方信息！")
        return;
      }
      if (this.order.orderCategory1 != 7 && this.order.orderCategory1 != 9 && this.order.orderCategory1 != 8 && this.order.orderCategory1 != 6 && !this.order.salesregion) {
        this.$msg.msge("请先选择销售区域！")
        return;
      }
      if (this.order.orderCategory1 != 7 && this.order.orderCategory1 != 9 && !this.order.customerChannelCode) {
        this.$msg.msge("请先选择客户渠道！")
        return;
      }
      this.showwuliaodialog = true
    },
    deleteThis2 (index, row) {
      this.$msg.confirm("确认删除？", () => {
        this.productList.splice(index, 1);
      })

    },
    // 删除套餐内产品信息
    deleteThis (index, row) {
      this.$msg.confirm("确认删除？", () => {
        // this.packageList.splice(index, 1);
        // if (this.packageList.length === 0) {
        //   this.packageTable = [];
        // }
        this.companyList.splice(index, 1);
        this.packageList = this.packageList.filter(item => item.packageCode != row.code);
        this.packageTable = this.packageTable.filter(item => item.packageCode !== row.code);
        console.log(this.packageList)
        console.log(this.packageTable)
      })
    },
    //保存订单备注信息
    saveRemark (row) {
      this.remark = row.note1;
    },
    //获取收货单位
    showFormList (value) {
      var data = value;
      ss.OrderMainService.getCompanyInfo(value).then(rd => {
        this.addrList = rd;
      })
    },
    //新增收货单位
    createAddress () {
      this.titleDig = "新建收货单位"
      this.institutionalX = true
      /*this.loadArea();*/
    },
    closeCompanyName (propData) {
      console.log(propData);
      this.closeDialog();
    },
    loadArea (i) {
      ss.Dictservice.arealist(this.proSelect).then(rd => {
        this.shenglist = rd;
        // for(let i = 0; i < this.shenglist.length; i++){
        //     this.shenglist[i].code = this.shenglist[i].code.substring(0,6);
        // }
        console.log("shenglist", this.shenglist)
      })
    },
    // 地图选点 弹出
    mapHandleShow () {
      this.mapDialogVisible = true;
      // this.$nextTick(() => {
      //   this.$refs.mapSrcVue.init(id)
      // })
    },
    choseMapShow (objs) {
      this.add.address = objs.address;
      this.add.deptName = objs.title;
      this.add.province = objs.province;
      this.add.city = objs.city;
      this.add.area = objs.district;
      this.add.longitude = objs.lng;
      this.add.latitude = objs.lat;
      this.loadArea();
      this.mapDialogVisible = false;
    },
    //获取单位名称信息
    selectDept (value) {
      ss.nxAddress.getDeptList(value).then(rd => {
        this.deptNameList = rd.msg;
      })
    },
    //省份选择器
    handleItemChange1 (o) {
      this.add.provinceId = o;
      this.address = _.find(this.shenglist, { code: this.add.provinceId });
      this.add.province = this.address.name;
      ss.Dictservice.areaTreelist({ code: o }).then(rd => {
        console.log("rddddddd", rd.zlist)
        this.add.city = '';
        this.add.area = '';
        this.arealist2 = rd.zlist;
        this.arealist3 = [];
      })
    },
    handleItemChange2 (o) {
      this.add.cityId = o;
      this.address = _.find(this.arealist2, { code: this.add.cityId });
      this.add.city = this.address.name;
      this.arealist3 = _.find(this.arealist2, { code: o }).zlist
      console.log("arealist3", this.arealist3)
      this.arealist4 = []
    },
    handleItemChange3 (o) {
      this.add.areaId = o;
      this.address = _.find(this.arealist3, { code: this.add.areaId });
      this.add.area = this.address.name;
    },
    commitCreate (v) {
      this.add.subFlag = '提交';
      this.add.countryId = '156';
      this.add.country = '中国';
      this.add.provinceId = this.add.provinceId.substring(0, 6);
      this.add.cityId = this.add.cityId.substring(0, 6);
      this.add.areaId = this.add.areaId.substring(0, 6);
      this.add.parentCode = this.stVal;
      var data = this.add;
      console.log("address", data)
      ss.nxAddress.insertAddress(data).then(rd => {
        this.closeDialog();
        this.query();
      })
    },
    //取消
    exit () {
      this.closeDialog()
    },
    closeDialog () {
      this.institutionalX = false
      this.newDialog = false
      this.updateDialog = false
      this.insertFlag = false
      this.reFlag = false
      //清空数据
      this.add.deptName = '';
      this.add.deptType = '';
      this.add.phone = '';
      this.add.leader = '';
      this.add.email = '';
      this.add.province = '';
      this.add.provinceId = '';
      this.add.city = '';
      this.add.cityId = '';
      this.add.area = '';
      this.add.areaId = '';
      this.add.landmark = '';
      this.add.address = '';
      this.add.parentCode = '';
      this.add.deptSourceChannel = '';
      this.stVal = null;
    },
    //获取当前登录人创建的所有父级单位
    getParentInfo () {
      ss.nxAddress.getParentInfo().then(rd => {
        this.options = rd.msg;
      })
    },
    //质量附件上传
    zlIsUpload (v) {
      console.log('zlIsUpload', v)
      if (v.length > 0) {
        //this.order.fileUrl = v[0].saveurl;
        let arrnew = []
        v.forEach(e => {
          arrnew.push(e.saveurl)
        })
        console.log(arrnew)
        this.order.zlfileUrl = arrnew
        console.log(this.order.zlfileUrl)
      } else {
        this.order.zlfileUrl = []
      }
    },
    httpRequest2 (params) {
      console.log(params, "1111111111")
      const loading = this.$msg.loading("上传中...");
      uploadFile.upload(params.file, { companycode: this.testID, reftype: this.reftype2 }).then(rd => {
        console.log("上传完毕后", rd);
        loading.close();
        this.fileList2.unshift(rd.obj);
        this.idList.push(rd.obj.id);
        this.order.upload2.unshift("1");
      }).catch(error => {
        loading.close();
        this.fileList2.splice(0, 1);
        return Promise.reject(error);
      });
      return false;
    },
    handleRemove2 (file) {
      console.log(file, "aaaaa");
      //删除文件
      var id = file.id;
      uploadFile.deleteById(id).then(response => {
        // console.log(response,"删除")
      })
      //删除fileList数据
      // console.log(this.fileList);
      for (var i = 0; i < this.fileList2.length; i++) {
        if (this.fileList2[i].id === id) {
          this.fileList2.splice(i, 1);
          // console.log(this.fileList)
        }
      }
    },
    beforeRemove (file) {
      if (file && file.status === "success") {
        return this.$confirm(`确定移除 ${file.name}？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        });
      }
    },
    beforeUpload (file) {
      const isFile = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg';
      if (!isFile) {
        this.$message.error('上传文件的格式只能是 JPG或PNG格式!');
        return false;
      }
    },
    getSchoolType () {
      for (var i = 0; i < this.addrList.length; i++) {
        var address = this.addrList[i];
        if (address.deptName == this.order.toCompanyname) {
          if (address.schoolTypeName != null && address.schoolTypeName != '') {
            this.showCollage = true;
          }
        }
      }
    },
    //渠道改变
    changeChannel (value) {
      console.log("value", value)
      ss.nxAddress.getAddressTypeByChannel(value.code).then(rd => {
        this.addressTypeList = rd.msg;
        this.add.schoolTypeName = '';
      })
    },
    changeSchoolType (value) {
      this.add.schoolTypeName = value;
    },
    changeDeptName (val) {
      console.log("changeDeptName", val)
      //匹配省市区信息
      ss.nxAddress.getAddressByWl(val).then(rd => {
        if (rd.f == true) {
          this.add.provinceId = rd.msg.provinceId;
          this.add.province = rd.msg.province;
          this.add.cityId = rd.msg.cityId;
          this.add.city = rd.msg.city;
          this.add.areaId = rd.msg.areaId;
          this.add.area = rd.msg.area;
          this.add.address = rd.msg.address;
          this.handleItemChangeN(this.add.provinceId);
        }
      })
      //根据单位名称获取关键字
      ss.nxAddressKeywords.matchKeywords(val).then(rd => {
        if (rd.msg != null) {
          this.add.deptSourceChannel = rd.msg.channelCode;
          this.add.schoolTypeName = rd.msg.userUnit;
          this.matchChannel(rd.msg.channelCode)
        }
      })
    },
    matchChannel (value) {
      console.log("value", value)
      ss.nxAddress.getAddressTypeByChannel(value).then(rd => {
        this.addressTypeList = rd.msg;
        // this.add.schoolTypeName = '';
      })
    },
    //地址选择器-新
    handleItemChangeN (o) {
      this.address = _.find(this.shenglist, { code: this.add.provinceId });
      // this.add.province = this.address.name;
      ss.Dictservice.areaTreelist({ code: o }).then(rd => {
        this.arealist2 = rd.zlist;
        this.arealist3 = [];
        this.address = _.find(this.arealist2, { code: this.add.cityId });
        // this.add.city = this.address.name;
        this.arealist3 = _.find(this.arealist2, { code: o }).zlist
      })
    },
    changeHhxmCode (value) {
      if (value == null || value == "") {
        this.isHHxm = false;
      } else {
        this.isHHxm = true;
      }
    },
    addPackageList(row){
      var filter = this.packageList.filter(item => item.id.toLowerCase().includes(row.id.toLowerCase()));
      filter[0].note1 = row.note1
      filter[0].yidishpyj = row.yidishpyj
    }
  }
}
</script>
<style scoped>
.combinatc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.queren {
  background-color: #006aca;
  color: white;
}

.anniu {
  display: flex;
  justify-content: center;
  align-items: center;
}

.zancun {
  background-color: #24b5b8;
  color: white;
}

.quxiao,
.zancun {
  width: 100px;
}

.jieguo {
  border-bottom: 1px solid rgb(238, 236, 236);
  display: flex;
}

.jieguo .jieguo_label {
  width: 2rem;
  text-align: right;
  background-color: #ebf5ff;
  font-size: 0.16rem;
  color: #616467;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0 0.05rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jieguo .jieguo_value {
  width: 19%;
  font-size: 0.16rem;
  color: #616467;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0px 8px;
}

img {
  width: 25px;
  padding: 5px 0;
}

.DshuR {
  width: 100%;
  height: 100%;
  border: none;
}

.n-xiao .h-formbLine .h-elformWrap-2,
.n-two .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
}
</style>
<style>
.n-two .h-formbLine .el-form-item__content .el-select,
.n-two .el-form .h-formbLine .el-form-item__content .el-select {
  width: 0;
}

.n-xiao .h-formbLine .el-form-item__label,
.n-two .h-formbLine .el-form-item__label {
  width: 43%;
}

.n-xiao .h-formbLine .el-form-item__content,
.n-two .h-formbLine .el-form-item__content {
  width: 57%;
}

.ljjtablepaddings2 .h-tableInput .el-input__inner {
  padding: 0.05rem 0.1rem;
}
.ljjtablepaddings2 .h-tableInput .el-input__icon {
  line-height: 0.25rem;
}
.ljjtablepaddings2 .ljjsales .el-input__inner {
  height: 0.3rem;
  line-height: 0.3rem;
}
.w-newIcon .el-input__icon {
  line-height: 0.4rem !important;
}
</style>
<style scoped lang="scss">
.bottomTip {
  position: absolute;
  left: 49.7%;
  bottom: 0.3rem;
  transform: translateX(-50%);
  z-index: 999999;
}

.newtext {
  font-size: 0.28rem;
  color: white;
  position: absolute;
  top: 0.2rem;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  text-shadow: 1px 1px 4px #2785e7;
  z-index: 2;
}

.leaderBox {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 99999;
  overflow: hidden;
  top: 0;
  left: 0;

  .leaderbg {
    width: 100%;
    height: 100%;
  }

  .createNxs {
    position: absolute;
    z-index: 1;
  }

  .createNx1 {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .createNxbtn {
    width: 1.9rem;
    height: 0.6rem;
    border: 0.03rem solid #ffffff;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    line-height: 0.5rem;
    position: absolute;
    z-index: 99;
    bottom: 0.75rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.27rem;
    letter-spacing: 2px;
    color: white;
    cursor: pointer;
  }

  .closeIt {
    width: 0.3rem;
    height: 0.4rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    cursor: pointer;
    z-index: 2;
  }
}
</style>
